import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      hy: {
        translation: {
          // Անալիտիկա և Ընդհանուր
          "about_us": "Մեր Մասին",
          "seo_title": "Liber Group | Նոր սերնդի լոգիստիկ էկոհամակարգ",
  "seo_description": "Liber Group: Ավտոմատացված լոգիստիկ հարթակ Երևանում։ 7-ը 1-ում ծառայություններ՝ օնլայն հաշվիչով և ֆիքսված գներով։",
  "seo_keywords": "բեռնափոխադրում, շինաղբի հեռացում, օնլայն հաշվիչ, liber group",
  "hero_badge": "ՆՈՐ ՍԵՐՆԴԻ ԹՎԱՅԻՆ ԷԿՈՀԱՄԱԿԱՐԳ",
  "auto_algorithm": "ԱՎՏՈՄԱՏԱՑՎԱԾ ԱԼԳՈՐԻԹՄ",
  "working_hours": "Համակարգն աշխատում է 24/7 ռեժիմով",
  "hero_highlights": ["ՇԻՆԱՂԲԻ ՀԵՌԱՑՈՒՄ", "ԲԵՌՆԱԹԱՓՈՒՄ", "ՊՐՈՖԵՍԻՈՆԱԼ ՄԱՔՐՈՒՄ", "ՎԱՐՊԵՏԻ ԾԱՌԱՅՈՒԹՅՈՒՆ", "ԲԵՌՆԱՓՈԽԱԴՐՈՒՄ", "ՍՄԱՐԹ ԼՈԳԻՍՏԻԿԱ"],
  "ecosystem_tag": "ԷԿՈՀԱՄԱԿԱՐԳ",
  "booking_title_1": "ԱՄՐԱԳՐՈՒՄ",
  "booking_title_2": "60 ՎԱՅՐԿՅԱՆՈՒՄ",
  "step_1_label": "ՓՈՒԼ 01",
  "step_1_desc": "Մուտքագրեք տվյալները և ստացեք ակնթարթային հաշվարկ",
  "step_2_label": "ՓՈՒԼ 02",
  "step_2_desc": "Պատվերի օնլայն կառավարում",
  "automated_note": "Լիովին ավտոմատացված գործընթաց",
  "home_services_title": "Մեր Ծառայությունները",
  "professional_service": "Պրոֆեսիոնալ ծառայություն",
  "home_see_more": "Տեսնել ավելին",
          // i18n.js-ի ներսում, hy -> translation բաժնում ավելացրու սա.
"seo": {
  "home_title": "Liber Group | Բեռնափոխադրում և Կենցաղային Ծառայություններ Երևանում",
  "home_description": "Liber Group-ը առաջարկում է որակյալ բեռնափոխադրում, մաքրության ծառայություններ և քանդման աշխատանքներ։ Արագ հաշվարկ և երաշխավորված որակ։",
  "services_title": "Մեր Ծառայությունները | Liber Group",
  "services_description": "Բացահայտեք Liber Group-ի ծառայությունների լայն տեսականին՝ բեռնափոխադրումից մինչև տեխնիկայի տրամադրում։",
  "projects_title": "Իրականացված Նախագծեր | Liber Group",
  "about_title": "Մեր Մասին | Liber Group - Փորձառու Թիմ",
  "contact_title": "Կապ Մեզ Հետ | Liber Group Հասցե և Հեռախոս",
  "hero_badge": "DIGITAL LOGISTICS 2026",
"hero_subtitle_1": "7 ՄԱՍՆԱԳԻՏԱՑՎԱԾ ՈՒՂՂՈՒԹՅՈՒՆՆԵՐ",
"hero_subtitle_2": "ԼԻԱՐԺԵՔ ԹՎԱՅՆԱՑՎԱԾ ՀԱՄԱԿԱՐԳ",
"stat_ops": "ԿԱՏԱՐՎԱԾ ՊԱՏՎԵՐՆԵՐ",
"stat_eff": "ԱՐԴՅՈՒՆԱՎԵՏՈՒԹՅՈՒՆ",
"stat_units": "ԳՈՐԾՈՂ ՄԱՍՆԱՃՅՈՒՂԵՐ"
},

          "loading": "Բեռնվում է...",
          "cars_management_title": "Մեքենաների Կառավարում",
  "cars_management_subtitle": "Ավելացրեք, խմբագրեք կամ հեռացրեք տրանսպորտային միջոցները",
  "search_placeholder": "Փնտրել ըստ համարի կամ տեսակի...",
  "add_car": "Ավելացնել մեքենա",
  "total": "Ընդհանուր",
  "gazels": "Գազելներ",
  "zils": "ԶԻԼ-եր",
  "loading": "Բեռնվում է",
  "image": "Նկար",
  "name_type": "Անվանում / Տեսակ",
  "parameters": "Պարամետրեր",
  "plate_number": "Պետհամարանիշ",
  "driver": "Վարորդ",
  "no_driver": "Վարորդ չկա",
  "action": "Գործողություն",
  "unit_ton": " տ",
  "unit_m3": " մ³",
  "unit_m": " մ",
  "no_cars_found": "Մեքենաներ չեն գտնվել",
  "delete_car_confirm": "Իսկապե՞ս ուզում եք հեռացնել այս մեքենան:",
  "edit_title": "Խմբագրել մեքենան",
  "label_display_name": "Մեքենայի անվանումը",
  "label_weight": "Առավելագույն քաշը",
  "label_volume": "Ծավալը",
  "label_plate": "Պետհամարանիշ",
  "save": "Պահպանել",
  "cancel": "Չեղարկել",
          
  "status": {
    "new": "Նոր",
    "processing": "Ընթացքի մեջ",
    "pending_admin": "Սպասում է ադմինին",
    "confirmed": "Հաստատված",
    "mismatch": "Անհամապատասխանություն",
    "modified": "Փոփոխված",
    "in_progress": "Կատարվում է",
    "pending_finish": "Ավարտի սպասում",
    "finished": "Ավարտված",
    "cancelled": "Չեղարկված"
  },
  "order": {
    "id_label": "Պատվեր #",
    "total_price": "Ընդհանուր գումար",
    "car": "Մեքենա",
    "worker": "Աշխատող"
  },
  "section": {
    "customer": "ՀԱՃԱԽՈՐԴ",
    "details": "ՄԱՆՐԱՄԱՍՆԵՐ",
    "workers": "ԱՇԽԱՏԱԿԻՑՆԵՐ"
  },
  "common": {
    "no_name": "Անունը նշված չէ",
    "no_data": "Տվյալներ չկան",
    "no_worker": "Աշխատողներ դեռ չկան",
    "note": "Նշում",
    "reason_prompt": "Նշեք չեղարկման պատճառը"
  },
  "btn": {
    "accept": "Ընդունել",
    "confirm": "Հաստատել",
    "confirm_order": "Հաստատել պատվերը",
    "match": "Համապատասխանեցնել",
    "problem": "Խնդիր կա",
    "confirm_finish": "Հաստատել ավարտը",
    "continue_old": "Շարունակել հինը",
    "recalculate": "Վերահաշվարկել",
    "finish": "Ավարտել",
    "change_progress": "Փոփոխել ընթացքը",
    "reject": "Մերժել"
  },
  "role": {
    "driver": "Վարորդ",
    "worker": "Աշխատող"
  },
  "timer": {
    "left": "Մնացել է",
    "delay": "Ուշացում"
  },
  "time": {
    "m": "ր",
    "s": "վ"
  },
  "confirm": {
    "remove_worker": "Հեռացնե՞լ աշխատողին պատվերից:"
  }
,
          "no_info_added": "Տեղեկատվությունը դեռ ավելացված չէ:",
          "total_visits": "Ընդհանուր Այցեր",
          "unique_users": "Unique Օգտատերեր",
          "total_orders": "Պատվերների Քանակ",
          "site_analytics": "Կայքի Անալիտիկա",

          // Calculators Hub (Նոր)
          "online_calculators": "ՕՆԼԱՅՆ ՀԱՇՎԻՉՆԵՐ",
          "nav_blog": "Բլոգ",
          "back_to_list": "ՀԵՏ ԴԵՊԻ ՑՈՒՑԱԿ",
          "calculate_btn": "ՀԱՇՎԵԼ",
          "order_now": "ՊԱՏՎԻՐԵԼ",
          "calc_trash_removal": "Շինարարական աղբի և հին անպիտան իրերի հեռացում",
          "calc_moving": "Բեռնափոխադրում",
          "calc_master": "Կենցաղային օգնական",
          "calc_demolition": "Քանդման աշխատանքներ և Աղբի հեռացում",
          "calc_cleaning": "Մաքրման աշխատանքներ",
          "calc_fura": "Ֆուռերի դատարկում",
          "calc_machinery": "Տեխնիկայի տրամադրում",
"admin": {
    "calculator_management": "Հաշվիչների Կառավարում",
    "new_calculator": "Նոր հաշվիչ",
    "navbars": "Մենյուի բաժիններ (Navbars)",
    "add_navbar": "Ավելացնել բաժին",
    "groups": "Խմբեր",
    "add_group": "Ավելացնել խումբ",
    "group_name": "Խմբի անուն",
    "asset_list": "Իրերի ցանկ (Assets)",
    "add_new_asset": "Ավելացնել նոր իր",
    "calculator_settings": "Հաշվիչի կարգավորումներ",
    "name": "Անուն",
    "icon": "Icon",
    "factor": "Գործակից",
    "weight": "Քաշ",
    "volume": "Ծավալ",
    "volume_m3": "Ծավալ (մ³)",
    "unit": "Միավոր",
    "unit_m2": "քմ",
    "unit_gmetr": "գծամետր",
    "unit_hat": "հատ",
    "unit_m3": "մ³",
    "price": "Գին",
    "actions": "Գործողություններ",
    "elevator": "Վերելակ",
    "fits_elevator": "Տեղավորվում է",
    "no_elevator": "Չի տեղավորվում",
    "h": "ժ",
    "min_hours": "Մին. ժամեր",
    "extra_price_hr": "Հավելյալ $/ժ",
    "key": "Բանալի (Key)",
    "ton": "Տոննա",
    "tech": "Տեխնիկա",
    "wood": "Փայտ",
    "pallet": "Պալետ",
    "big_box": "Մեծ արկղ",
    "front_id": "Frontend ID",
    "density": "Խտություն",
    "group": "Խումբ",
    
    "min_order_price": "Պատվերի մին. գին",
    "base_weight": "Բազային քաշ",
    "base_volume": "Բազային ծավալ",
    "price_per_km": "Գինը 1 կմ-ի համար",
    "free_distance": "Անվճար հեռավորություն",
    "elevator_fee": "Վերելակի վճար",
    "stairs_fee": "Աստիճանների վճար",
    "discounts_json": "Զեղչերի կոնֆիգ (JSON)",
    "name_required": "Անվանումը պարտադիր է",
    "add_failed": "Ավելացումը չհաջողվեց",
    "missing_edit_data": "Խմբագրման տվյալները բացակայում են",
    "endpoint_not_found": "Հասցեն չի գտնվել",
    "select_calculator_first": "Նախ ընտրեք հաշվիչը",
    "limit_reached": "Սահմանաչափը լրացել է"
  },
  "common": {
    "add": "Ավելացնել",
    "save_changes": "Պահպանել փոփոխությունները",
    "saving": "Պահպանվում է...",
    "updated_successfully": "Տվյալները թարմացվեցին",
    "update_error": "Թարմացման սխալ",
    "saved_successfully": "Պահպանված է",
    "save_error": "Պահպանման սխալ",
    "are_you_sure": "Վստա՞հ եք",
    "delete_error": "Ջնջման սխալ"
  },
          // Admin Sidebar & Menu
          "admin_analytics": "Վիճակագրություն",
          "admin_workers": "Աշխատողներ",
          "admin_users": "Օգտատերեր",
          "admin_wallet": "Դրամապանակ",
          "admin_orders": "Պատվերներ",
          "admin_assets": "Հաշվիչի իրեր",
          "admin_cars": "Մեքենաներ",
          "admin_messages": "Նամակներ",
          "admin_bot": "Բոտի ուսուցում",
          "admin_notifications": "Ծանուցումներ",
          "admin_portfolio": "Նախագծեր",
          "admin_services": "Ծառայություններ",
          "admin_slides": "Սլայդեր",
          "admin_categories": "Կատեգորիաներ",
          "admin_partners": "Գործընկերներ",
          "admin_reviews": "Կարծիքներ",
          "admin_faq": "FAQ",
          "admin_about": "Մեր մասին",
          "admin_contacts": "Կոնտակտներ",

          // Admin Auth & UI
          "admin_welcome": "Բարի գալուստ, մուտք գործեք համակարգ",
          "username": "Մուտքանուն",
          "password": "Գաղտնաբառ",
          "login_btn": "ՄՈՒՏՔ ԳՈՐԾԵԼ",
          "logout": "ԵԼՔ",

          // Կարգավիճակներ (Statuses)
          "status_new": "ՆՈՐ ՊԱՏՎԵՐ",
          "status_processing": "ՄՇԱԿՄԱՆ ՄԵՋ",
          "status_pending_admin": "ՍՊԱՍՈՒՄ Է",
          "status_confirmed": "ՀԱՍՏԱՏՎԱԾ",
          "status_mismatch": "ԽՆԴԻՐ / SOS",
          "status_in_progress": "ԸՆԹԱՑՔԻ ՄԵՋ",
          "status_finished": "ԱՎԱՐՏՎԱԾ",
          "status_cancelled": "ՉԵՂԱՐԿՎԱԾ",
          "contact_us_title": "ԿԱՊ ՀԱՍՏԱՏԵԼ",
           "contact_us_subtitle": "Ընտրեք կապի ձեզ հարմար տարբերակը",
         "call_button": "ԶԱՆԳԱՀԱՐԵԼ",
          "cancel_btn": "Չեղարկել",

          // Notifications
          "notif_new": "Նոր",
          "notif_confirmed": "Հաստատված ✅",
          "notif_cancelled": "Չեղարկված ❌",
          "notif_completed": "Ավարտված ✨",
          "bot_welcome": "Բարև Ձեզ! Ես Liber Bot-ն եմ: Ինչո՞վ կարող եմ օգնել:",
"bot_placeholder": "Գրեք Ձեր հարցը...",
"bot_online": "Առցանց",
"bot_error_response": "Ներողություն, չկարողացա մշակել պատասխանը:",
"bot_connection_error": "Կապի սխալ։ Խնդրում ենք փորձել մի փոքր ուշ։",
"contact_back": "Հետ",
"contact_main_title": "ԿԱՊ ՄԵԶ ՀԵՏ",
"contact_tab_write": "Գրել",
"contact_tab_inbox": "Պատասխաններ",
"contact_form_title": "Հետադարձ Կապ",
"contact_label_name": "Անուն",
"contact_label_phone": "Հեռախոս",
"contact_label_subject": "Թեմա",
"contact_label_message": "Հաղորդագրություն",
"contact_subject_placeholder": "Ինչի՞ վերաբերյալ է հարցը",
"contact_attach_image": "Կցել նկար",
"contact_file_selected": "Ընտրված է",
"contact_btn_send": "ՈՒՂԱՐԿԵԼ ՆԱՄԱԿԸ",
"contact_sending": "Ուղարկվում է...",
"contact_success": "Ուղարկված է",
"contact_login_required": "Խնդրում ենք նախ մուտք գործել",
"contact_no_messages": "Նամակներ չկան",
"contact_reply_from": "Պատասխան Liber Group-ից",
"contact_view_attachment": "Տեսնել կցված ֆայլը",
"contact_delete_confirm": "Ջնջե՞լ այս նամակը",
"contact_default_subject": "Հարցում",
"faq_main_title": "Հաճախ տրվող հարցեր",
"faq_q1": "Ինչպե՞ս կատարել պատվեր:",
"faq_a1": "Ընտրեք ծառայությունը, սեղմեք «Պատվիրել» կոճակը և լրացրեք ձեր տվյալները:",
"faq_q2": "Որքա՞ն ժամանակում կմոտենա մասնագետը:",
"faq_a2": "Պատվերը հաստատելուց հետո մասնագետը կմոտենա 1 ժամվա ընթացքում:",
"faq_q3": "Տրվո՞ւմ է երաշխիք:",
"faq_a3": "Այո, մենք տրամադրում ենք որակի երաշխիք բոլոր աշխատանքների համար:",
"fav_loading": "Բեռնվում է...",
"fav_back": "Հետ",
"fav_title": "Իմ սիրվածները",
"fav_subtitle": "Ձեր կողմից հավանած ծառայությունների հավաքածուն",
"fav_empty_title": "Ցանկը դատարկ է",
"fav_empty_text": "Դուք դեռ չունեք նախընտրած ծառայություններ:",
"fav_explore_btn": "Բացահայտել ծառայություններ",
"fav_price_contract": "Պայմանագրային",
"footer_rights": "Բոլոր իրավունքները պաշտպանված են:",
"footer_company": "Ընկերություն",
"footer_about": "Մեր մասին",
"footer_projects": "Նախագծեր",
"footer_terms": "Օգտագործման պայմաններ",
"footer_contact": "Կապ մեզ հետ",
"nav_home": "Գլխավոր",
"nav_services": "Ծառայություններ",
"nav_projects": "Նախագծեր",
"nav_about": "Մեր մասին",
"nav_contact": "Կապ",
"nav_login": "ՄՈՒՏՔ",
"nav_register": "ԳՐԱՆՑՈՒՄ",
"nav_profile": "Իմ պրոֆիլը",
"nav_orders": "Պատվերներ",
"nav_favorites": "Սիրվածներ",
"nav_logout": "Ելք",
"loading": "Բեռնվում է...",
"home_hero_slogan": "ՊՐՈՖԵՍԻՈՆԱԼ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐ",
"home_quick_contact": "ԱՐԱԳ ԿԱՊ",
"home_services_title": "ՄԵՐ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԸ",
"home_card_badge": "ԱՐԱԳ ԵՎ ՈՐԱԿՅԱԼ",
"home_see_more": "ՏԵՍՆԵԼ ԱՎԵԼԻՆ",
"inv_prof_service": "Պրոֆեսիոնալ Մաքրման Ծառայություններ",
"inv_title": "ԻՆՎՈՅՍ",
"inv_number": "Համար",
"inv_date": "Ամսաթիվ",
"inv_from": "Ում կողմից",
"inv_company_name": "Լիբեր Սերվիս ՍՊԸ",
"inv_company_addr": "Երևան, Հայաստան",
"inv_customer": "Հաճախորդ",
"inv_dear_customer": "Հարգելի հաճախորդ",
"inv_th_service": "Ծառայություն",
"inv_th_qty": "Քանակ",
"inv_th_price": "Գին",
"inv_total": "Ընդհանուր",
"inv_btn_download": "Ներբեռնել PDF",
"inv_btn_close": "Փակել",
"login_subtitle": "Մուտք գործեք համակարգ",
"login_username": "Մուտքանուն",
"login_username_placeholder": "Մուտքանուն",
"login_password": "Գաղտնաբառ",
"login_password_placeholder": "Գաղտնաբառ",
"login_btn_submit": "Մուտք",
"login_btn_loading": "Մուտք...",
"login_error_failed": "Մուտքը մերժվեց",
"login_error_server": "Սերվերը անհասանելի է։ Ստուգեք կապը։",
"nav_home": "ԳԼԽԱՎՈՐ",
"nav_projects": "ՆԱԽԱԳԾԵՐ",
"nav_about": "ՄԵՐ ՄԱՍԻՆ",
"nav_favorites": "ՍԻՐՎԱԾՆԵՐ",
"nav_services": "ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐ",
"nav_contact": "ԿԱՊ",
"nav_login": "ՄՈՒՏՔ",
"nav_profile": "ԻՄ ԷՋԸ",
"nav_orders": "Պատվեր",
"admin_notifications": "Ծանուցումներ",
"admin_partners": "ԳՈՐԾԸՆԿԵՐՆԵՐ",
"online_calculators": "ՀԱՇՎԻՉՆԵՐ",
"home_see_more": "ՏԵՍՆԵԼ ԲՈԼՈՐԸ",
"contact_label_subject": "Վերնագիր",
"contact_label_message": "Հաղորդագրություն",
"contact_subject_placeholder": "Վերնագիր (օր.՝ Զեղչեր)",
"contact_btn_send": "Ուղարկել Բոլորին",
"contact_sending": "Ուղարկվում է...",
"contact_success": "Ծանուցումը հաջողությամբ ուղարկվեց",
"contact_tab_inbox": "Պատմություն",
"contact_no_messages": "Պատմությունը դատարկ է",
"contact_delete_confirm": "Ջնջե՞լ այս պատմությունը:",
"status_new": "Նոր",
"status_pending": "Ընթացքի մեջ",
"status_completed": "Ավարտված",
"bot_connection_error": "Կապի սխալ",
"bot_error_response": "Սխալ",
"status_label": "Կարգավիճակը",
"status_pending": "Սպասվում է",
"status_in_progress": "Ընթացքում է",
"status_completed": "Ավարտված",
"status_cancelled": "Չեղարկված",
"notification_center_title": "Ծանուցումների կենտրոն",
"login_required_notifs": "Խնդրում ենք մուտք գործել՝ ծանուցումները տեսնելու համար",
"notif_type_global": "ՀԱՄԸՆԴՀԱՆՈՒՐ",
"notif_type_personal": "ԱՆՁՆԱԿԱՆ",
"order_finish_payment": "Ավարտ և Վճարում",
"order_finish_subtitle": "Հաստատեք և վճարեք պատվերը փակելու համար",
"payment_method_label": "Վճարման եղանակ",
"payment_method_cash": "Կանխիկ",
"payment_method_online": "Օնլայն",
"payment_method_later": "Վճարել հետո (Պարտք)",
"online_payment_instruction": "Փոխանցեք գումարը և սեղմեք հաստատել.",
"payment_comment_warning": "Գրեք այս կոդը մեկնաբանության մեջ՝",
"rate_master_label": "Գնահատեք վարպետին",
"btn_confirm_transfer": "✅ ՓՈԽԱՆՑԵԼ ԵՄ (ՀԱՍՏԱՏԵԼ)",
"btn_confirm_payment": "ՀԱՍՏԱՏԵԼ ՎՃԱՐՈՒՄԸ",
"price_change_title": "Գնի փոփոխություն",
"price_change_subtitle": "Վարպետը առաջարկում է նոր գին",
"btn_agree": "Համաձայն եմ",
"btn_reject": "Մերժել",
"floating_pay_waiting": "Վճարման սպասող պատվեր",
"floating_price_change": "Գնի փոփոխության հաստատում",
"btn_copy": "Copy",
"copy_status_success": "Պատճենված է",
"btn_back": "Հետ",
"order_confirmation_title": "Հաստատում",
"fill_required_fields": "Լրացրեք պարտադիր դաշտերը *",
"form_full_name": "Անուն Ազգանուն",
"form_phone": "Հեռախոս",
"form_date": "Օր",
"form_time": "Ժամ",
"form_address": "Հասցե",
"form_notes": "Նշումներ",
"placeholder_name": "Անուն",
"placeholder_address": "Փողոց, տուն...",
"placeholder_notes": "Լրացուցիչ ինֆո...",
"btn_confirm_order": "ՀԱՍՏԱՏԵԼ ՊԱՏՎԵՐԸ",
"gps_not_supported": "GPS-ը չի աջակցվում",
"location_fetch_error": "Չհաջողվեց ստանալ լոկացիան",
"order_success_msg": "Պատվերը հաջողությամբ գրանցվեց ✅",
"order_failed_msg": "Չհաջողվեց գրանցել",
"error_label": "Սխալ",
"default_service_name": "ՇԻՆԱՂԲԻ ՀԵՌԱՑՈՒՄ",
  "partners_title_prefix": "Մեր",
  "partners_title_main": "Գործընկերները",
  "loading": "Բեռնվում է",
  "no_partners": "Գործընկերներ դեռ չկան",
  "portfolio_title_prefix": "Մեր",
  "portfolio_title_main": "Նախագծերը",
  "portfolio_subtitle": "Յուրաքանչյուր նախագիծ մեր որակի և պրոֆեսիոնալիզմի վկայությունն է",
  "portfolio_photo_count": "Լուսանկար",
  "no_projects": "Աշխատանքներ դեռ չկան:",
  "loading": "Բեռնվում է",
  "register_page_title": "Գրանցում",
  "register_subtitle": "Ստեղծեք Ձեր հաշիվը հիմա",
  "form_full_name": "Անուն Ազգանուն",
  "form_email": "Էլ. հասցե",
  "form_phone": "Հեռախոսահամար",
  "form_password": "Գաղտնաբառ",
  "form_confirm_password": "Կրկնել գաղտնաբառը",
  "placeholder_name": "Արամ Արամյան",
  "pass_hint_chars": "8+ նիշ",
  "pass_hint_number": "Թիվ",
  "pass_hint_upper": "Մեծատառ",
  "error_pass_mismatch": "Գաղտնաբառերը չեն համընկնում",
  "btn_create_account": "Ստեղծել հաշիվ",
  "already_have_account": "Արդեն ունե՞ք հաշիվ:",
  "login_link": "Մուտք",
  "register_success_alert": "Շնորհավորում ենք: Գրանցումը հաջողությամբ ավարտվեց:",
  "error_404_server": "Սխալ. Կապի հասցեն չի գտնվել (404):",
  "register_error_generic": "Գրանցման սխալ. Տվյալները արդեն օգտագործվում են:",
  "error_server_unavailable": "Սերվերը անհասանելի է: Ստուգեք կապը:",
  "review_access_denied": "Մուտքը սահմանափակ է",
"review_login_prompt": "Մուտք գործեք ձեր էջ կարծիք թողնելու համար",
"alert_select_stars": "Խնդրում ենք ընտրել աստղիկների քանակը",
"alert_write_review": "Խնդրում ենք գրել Ձեր կարծիքը",
"alert_relogin": "Նորից մուտք գործեք համակարգ",
"customer_default_name": "Հաճախորդ",
"review_success_msg": "Կարծիքն ուղարկվեց։ Շնորհակալություն ✅",
"review_error_msg": "Չհաջողվեց ուղարկել կարծիքը",
"error_server_connection": "Կապի սխալ սերվերի հետ",
"review_form_title": "Թողնել կարծիք",
"review_form_subtitle": "Ձեր կարծիքը կարևոր է մեզ համար",
"placeholder_review_text": "Ինչպե՞ս կգնահատեք մատուցված ծառայությունը...",
"btn_sending": "Ուղարկվում է...",
"btn_send_review": "Ուղարկել կարծիքը",
"review_anonymous": "Անանուն",
"search_placeholder": "Փնտրել ծառայություն...",
"alert_login_to_review": "Մուտք գործեք կարծիք թողնելու համար:",
"alert_write_text": "Խնդրում ենք գրել տեքստը:",
"review_sent_success": "✅ Կարծիքն ուղարկվեց",
"error_generic": "Սխալ տեղի ունեցավ",
"service_not_found": "Ծառայությունը չգտնվեց",
"seo_description_suffix": "Երևանում։ Արագ հաշվարկ և որակյալ սպասարկում։",
"btn_back": "Հետ",
"reviews_count_label": "կարծիք",
"order_guide_title": "Պատվիրման ուղեցույց",
"step_1_title": "Հաշվարկեք",
"step_1_desc": "Սեղմեք «Հաշվել գինը» և անցեք հաշվիչին",
"step_2_title": "Պատվիրեք",
"step_2_desc": "Հաստատեք հաշվարկը և կատարեք պատվեր",
"info_guarantee": "100% Երաշխիք",
"info_fast_service": "Արագ Սպասարկում",
"cta_ready_to_calc": "Պատրաստ եք հաշվարկի՞",
"btn_calculate_price": "Հաշվել գինը",
"customer_reviews_title": "Հաճախորդների կարծիքները",
"placeholder_write_review": "Թողեք Ձեր կարծիքը այստեղ...",
"btn_send": "Ուղարկել",
"no_reviews_yet": "Դեռ կարծիքներ չկան",
"reviews_count_label": "կարծիք",
"description_title": "Նկարագրություն",
"no_description_available": "Այս ծառայության համար մանրամասն նկարագրություն դեռ ավելացված չէ։",
"btn_order_now": "ՊԱՏՎԻՐԵԼ ՀԻՄԱ",
"customer_reviews_title": "Հաճախորդների կարծիքներ",
"placeholder_write_review": "Թողեք Ձեր կարծիքը...",
"btn_send": "Ուղարկել",
"example_reviewer_name": "Արմեն Գևորգյան",
"example_review_text": "Շատ լավ ու որակով ծառայություն է, խորհուրդ եմ տալիս։",
"social_share_title": "Միացեք մեզ և կիսվեք կայքով",
"share_nav_text": "Որակյալ շինարարություն և ժամանակակից լուծումներ",
"alert_link_copied": "Հղումը պատճենվեց հիշողության մեջ (Copy)։",
"btn_share": "Կիսվել",
"no_services_found_in_category": "«{{category}}» բաժնում ծառայություններ չգտնվեցին",
"back_to_home": "Վերադառնալ Գլխավոր",
"price_on_request": "Գինը հարցումով",
"view_details": "Դիտել մանրամասները",
"login_page_title": "Մուտք",
"login_subtitle": "Մուտք գործեք շարունակելու համար",
"label_email_or_phone": "Էլ. հասցե կամ Հեռախոս",
"placeholder_login_input": "Մուտքագրեք ձեր տվյալները",
"label_password": "Գաղտնաբառ",
"link_forgot_password": "Մոռացե՞լ եք",
"btn_login": "Մուտք Գործել",
"no_account_text": "Դեռ հաշիվ չունե՞ք:",
"link_register": "Գրանցվել",
"error_phone_short": "Հեռախոսահամարը պետք է լինի առնվազն 9 նիշ",
"error_password_short": "Գաղտնաբառը պետք է լինի առնվազն 6 նիշ",
"error_login_failed": "Մուտքի սխալ",
"error_server_connection": "Կապի սխալ սերվերի հետ",
"terms_title": "Օգտագործման պայմաններ",
"last_updated": "Վերջին թարմացումը՝",
"loading": "Բեռնվում է...",
"btn_back": "Վերադառնալ",
"terms_sec1_title": "1. Ընդհանուր դրույթներ",
"terms_sec1_text": "Բարի գալուստ Liber Group կայք։ Մեր կայքից օգտվելով՝ Դուք համաձայնում եք սույն պայմանների հետ։",
"terms_sec2_title": "2. Ծառայությունների մատուցում",
"terms_sec2_text": "Կայքում ներկայացված բոլոր ծառայությունները կրում են տեղեկատվական բնույթ։ Յուրաքանչյուր պատվեր ձևակերպվում է առանձին պայմանագրով։",
"terms_sec3_title": "3. Գաղտնիություն",
"terms_sec3_text": "Ձեր կողմից տրամադրված անձնական տվյալները օգտագործվում են բացառապես Ձեզ հետ հետադարձ կապ հաստատելու համար։",
  "my_profile_btn": "ԻՄ ԷՋԸ",
  "login_btn": "ՄՈՒՏՔ",
  "contact_btn": "ԿԱՊ",
  "notifications_header": "ԾԱՆՈՒՑՈՒՄՆԵՐ",
  "notif_order_label": "Պատվեր",
  "notif_info": "Տեղեկություն",
  "notif_announcement": "Հայտարարություն",
  "no_new_notifications": "Նոր ծանուցումներ չկան",
  "see_all_notifications": "ՏԵՍՆԵԼ ԲՈԼՈՐԸ",
  "nav_home": "ԳԼԽԱՎՈՐ",
  "nav_projects": "ՆԱԽԱԳԾԵՐ",
  "nav_about": "ՄԵՐ ՄԱՍԻՆ",
  "nav_favorites": "ՍԻՐՎԱԾՆԵՐ",
  "nav_services": "ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐ",
  "nav_partners": "ԳՈՐԾԸՆԿԵՐՆԵՐ",
  "nav_calculators": "ՀԱՇՎԻՉՆԵՐ",
  "nav_contact": "ԿԱՊ",
  "back_to_profile": "Հետ դեպի պրոֆիլ",
    "filter_current": "Ընթացիկ",
    "filter_completed": "Ավարտված",
    "filter_cancelled": "Չեղարկված",
    "orders_count": "պատվեր",
    "loading": "Բեռնվում է...",
    "no_orders": "Այս բաժնում պատվերներ չկան",
    "no_address": "Հասցեն նշված չէ",
    "total_price": "Ընդհանուր՝",
    "currency": "֏",
    "btn_pay": "ՎՃԱՐԵԼ",
    "btn_invoice": "Ինվոյս",
    "btn_cancel": "Չեղարկել",
    "login_required": "Խնդրում ենք մուտք գործել:",
    "rating_done": "Ձեր գնահատականը",
    "rating_ask": "Ինչպե՞ս կգնահատեք աշխատանքը",
    "cancel_confirm": "Վստա՞հ եք, որ ուզում եք չեղարկել այս պատվերը:",
    "cancel_success": "✅ Պատվերը հաջողությամբ չեղարկվեց",
    "cancel_error": "🚨 Սխալ չեղարկելիս",
    "review_success": "Շնորհակալություն գնահատականի համար ✅",
    "review_error": "Չհաջողվեց գրանցել գնահատականը:",
    "connection_error": "Կապի սխալ. Socket-ը հասանելի չէ:",
    "new": "Նոր",
      "processing": "Մշակվում է",
      "confirmed": "Հաստատված",
      "arrived": "Ընթացքի մեջ",
      "pending_finish": "Սպասում է հաստատման",
      "finished": "Ավարտված",
      "cancelled": "Չեղարկված",
      "title": "ԻՄ ԷՋԸ",
    "role_worker": "ՄԱՍՆԱԳԵՏ",
    "role_customer": "ՀԱՃԱԽՈՐԴ",
    "tab_orders": "ՊԱՏՎԵՐՆԵՐ",
    "tab_info": "ՏՎՅԱԼՆԵՐ",
    "tab_settings": "ԿԱՐԳԱՎՈՐՈՒՄ",
    "recent_orders": "ՎԵՐՋԻՆ ՊԱՏՎԵՐՆԵՐ",
    "order_id": "Պատվեր",
    "loading": "Բեռնվում է...",
    "no_orders": "Պատվերներ չեն գտնվել",
    "see_all": "ՏԵՍՆԵԼ ԲՈԼՈՐԸ",
    "full_name": "ԱՆՈՒՆ ԱԶԳԱՆՈՒՆ",
    "email": "ԷԼ․ ՓՈՍՏ (EMAIL)",
    "phone_1": "ՀԵՌԱԽՈՍ 1",
    "phone_2": "ՀԵՌԱԽՈՍ 2",
    "address": "ՀԱՍՑԵ",
    "save_changes": "ՊԱՀՊԱՆԵԼ ՓՈՓՈԽՈՒԹՅՈՒՆՆԵՐԸ",
    "notifications": "ԾԱՆՈՒՑՈՒՄՆԵՐ",
    "email_notify": "Email ծանուցումներ",
    "sms_notify": "SMS ծանուցումներ",
    "reg_date": "Գրանցման ամսաթիվ",
    "logout": "ԵԼՔ",
    "update_success": "Տվյալները հաջողությամբ թարմացվեցին",
    "update_error": "Տվյալների թարմացման սխալ",
    "missing_data": "Օգտատիրոջ տվյալները բացակայում են",
    "conn_error": "Կապի սխալ սերվերի հետ",
  "back_to_profile": "Հետ դեպի պրոֆիլ",
  "tab_current": "Ընթացիկ",
  "tab_completed": "Ավարտված",
  "tab_cancelled": "Չեղարկված",
  "orders_count": "պատվեր",
  "loading": "Բեռնվում է",
  "no_orders_in_section": "Այս բաժնում պատվերներ չկան",
  "no_address": "Հասցեն նշված չէ",
  "your_rating": "Ձեր գնահատականը",
  "rate_work": "Ինչպե՞ս կգնահատեք աշխատանքը",
  "total_price_label": "Ընդհանուր",
  "btn_pay": "ՎՃԱՐԵԼ",
  "btn_invoice": "Ինվոյս",
  "btn_cancel": "Չեղարկել",
  "alert_socket_error": "Կապի սխալ. Socket-ը հասանելի չէ:",
  "customer_default_name": "Հաճախորդ",
  "rating_for_order": "Գնահատական պատվերի համար",
  "alert_rating_success": "Շնորհակալություն գնահատականի համար ✅",
  "alert_rating_error": "Չհաջողվեց գրանցել գնահատականը:",
  "confirm_cancel_order": "Վստա՞հ եք, որ ուզում եք չեղարկել այս պատվերը:",
  "alert_cancel_success": "✅ Պատվերը հաջողությամբ չեղարկվեց",
  "alert_cancel_error": "🚨 Սխալ չեղարկելիս",
  "back_btn": "Հետ",
  "reviews_count": "կարծիք",
  "price_from": "Արժեքը սկսած",
  "order_now_btn": "Պատվիրել հիմա",
  "customer_reviews_title": "Հաճախորդների կարծիքները",
  "no_reviews_yet": "Այս ծառայության համար դեռ կարծիքներ չկան: Եղեք առաջինը:",
  "service_not_found": "Ծառայությունը չգտնվեց",
  "return_home": "Վերադառնալ գլխավոր էջ",
  "alert_cancel_success": "✅ Պատվերը չեղարկված է:",
  "alert_cancel_error": "🚨 Չհաջողվեց չեղարկել:",
  "back_btn": "Հետ",
  "reviews_count": "կարծիք",
  "price_from": "Արժեքը սկսած",
  "order_now_btn": "Պատվիրել հիմա",
  "customer_reviews_title": "Հաճախորդների կարծիքները",
  "no_reviews_yet": "Այս ծառայության համար դեռ կարծիքներ չկան: Եղեք առաջինը:",
  "service_not_found": "Ծառայությունը չգտնվեց",
  "return_home": "Վերադառնալ գլխավոր էջ",
  "back_to_profile": "Հետ դեպի պրոֆիլ",
  "tab_current": "Ընթացիկ",
  "tab_completed": "Ավարտված",
  "tab_cancelled": "Չեղարկված",
  "orders_count": "պատվեր",
  "loading": "Բեռնվում է",
  "no_orders_in_section": "Այս բաժնում պատվերներ չկան",
  "no_address": "Հասցեն նշված չէ",
  "rate_work": "Գնահատեք աշխատանքը",
  "your_rating": "Ձեր գնահատականը",
  "total_price_label": "Ընդհանուր գումար",
  "btn_pay": "Հաստատել և վճարել",
  "btn_invoice": "Հաշիվ-ապրանքագիր",
  "btn_cancel": "Չեղարկել",
  "please_login": "Խնդրում ենք մուտք գործել",
  "status_new": "Նոր",
  "status_processing": "Ընթացքի մեջ",
  "status_confirmed": "Հաստատված",
  "status_arrived": "Ժամանել է",
  "status_pending_pay": "Սպասում է վճարման",
  "status_finished": "Ավարտված",
  "status_cancelled": "Չեղարկված",
  "alert_socket_error": "Կապի սխալ: Փորձեք նորից:",
  "alert_rating_success": "Շնորհակալություն գնահատականի համար:",
  "alert_rating_error": "Սխալ գնահատման ժամանակ:",
  "confirm_cancel_order": "Վստա՞հ եք, որ ուզում եք չեղարկել պատվերը:",
  "customer_default_name": "Հաճախորդ",
  "rating_for_order": "Գնահատական պատվերի համար",
  "view_all_orders": "ՏԵՍՆԵԼ ԲՈԼՈՐԸ",
  "address_label": "Հասցե",
  "address_placeholder": "Մուտքագրեք հասցեն...",
  "floor_label": "Հարկ",
  "elevator_label": "Վերելակ",
  "elevator_none": "Չկա",
  "elevator_small": "Մարդատար",
  "elevator_large": "Բեռնատար",
  "calculate_btn": "ՀԱՇՎԱՐԿԵԼ",
  "new_calc_btn": "ՆՈՐ ՀԱՇՎԱՐԿ",
  "select_item_alert": "Խնդրում ենք ընտրել առնվազն մեկ ապրանք",
  "address": "📍 Հասցե",
  "floor": "🏢 Հարկ",
  "elevator": "🛗 Վերելակ",
  "items_list": "📦 Բեռների ցանկ",
  "selected_items": "Ընտրված ապրանքներ",
  "summary": "🚛 Ամփոփում",
  "not_specified": "Նշված չէ",
  "error": "Հաշվարկի սխալ",
  "single_address": "Մեկ հասցե",
"need_packing": "Փաթեթավորում",
"need_truck": "Բեռնատար",
"search_placeholder": "Փնտրել իր...",
"total_price": "Ընդհանուր գին",
"master_title": "🛠 ՎԱՐՊԵՏԻ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐ",
"by_meter": "ըստ մետրի",
"by_count": "ըստ քանակի",
"calculation_result": "Հաշվարկի արդյունք",
"total": "Ընդհանուր՝",
"back_btn": "ՎԵՐԱԴԱՌՆԱԼ",
"meter_unit": "մ",
"demolition_title": "ՔԱՆԴՄԱՆ ԱՇԽԱՏԱՆՔՆԵՐ",
"address_placeholder_house": "Փողոց, տուն...",
"elevator_none_short": "Չկա",
"elevator_small_short": "Մարդ.",
"elevator_large_short": "Բեռն.",
"search_work": "Փնտրել աշխատանք...",
"cm": "ՍՄ",
"modify": "ՓՈՓՈԽԵԼ",
"select_work_alert": "Խնդրում ենք ընտրել գոնե մեկ աշխատանք",
"select_cargo_type": "Ընտրեք բեռի տեսակը",
"no_data_found": "Տվյալներ չեն գտնվել բազայում",
"fill_hours_alert": "Խնդրում ենք լրացնել ժամերի քանակը",
"fill_qty_alert": "Խնդրում ենք լրացնել քանակը",
"qty_label": "Քանակ",
"hours_label": "Ժամերի քանակ",
"weight_label": "Ընդհանուր Քաշ (Տոննա)",
"distance_label": "Հեռավորություն (Մետր)",
"dist_placeholder": "0-10մ անվճար",
"back_to_menu": "Վերադառնալ մենյու",
"calculation_ready": "Հաշվարկը պատրաստ է",
"total_sum": "ԸՆԴՀԱՆՈՒՐ ԳՈՒՄԱՐ",
"cargo_type": "Բեռի տեսակ",
"distance": "Հեռավորություն",
"time": "Ժամանակ",
"unit_m3": "խմ",
"unit_pcs": "հատ",
"unit_ton": "տ",
"unit_hour": "ժամ",
"unit_meter": "մ",
"machinery_title": "Հատուկ տեխնիկա",
"machinery_subtitle": "Ընտրեք տեսակը և ժամաքանակը",
"min_hours": "մինիմալը՝ {{count}} ժամ",
"selected_hours": "{{count}} ժամ",
"hour_quantity": "Ժամաքանակ",
"calculation_ready": "Հաշվարկը պատրաստ է",
"order_summary": "ՊԱՏՎԵՐԻ ԱՄՓՈՓՈՒՄ",
"total": "Ընդհանուր",
"machinery_label": "Տեխնիկա",
"calculate_btn": "ՀԱՇՎԱՐԿԵԼ",
"modify_btn": "ՓՈՓՈԽԵԼ",
"calculation_error": "Հաշվարկի սխալ",
    "total_visits": "Ընդհանուր Այցեր",
    "unique_users": "Unique Օգտատերեր",
    "total_orders": "Պատվերների Քանակ",
    "site_analytics": "Կայքի Անալիտիկա",
    "top_categories": "Թոփ Կատեգորիաներ",
    "top_subservices": "Թոփ Ենթածառայություններ",
    "search_frequency": "Որոնման Հաճախականություն",
    "filter_placeholder": "Ֆիլտրել որոնումները...",
    "category": "Կատեգորիա",
    "service": "Ծառայություն",
    "views": "Դիտումներ",
    "times": "անգամ",
    "no_data": "Տվյալներ չկան",
    "delete_confirm": "Ջնջե՞լ այս որոնման պատմությունը:",
    "loading": "Բեռնվում է...",
    "loading": "Բեռնվում է...",
  "delete_car_confirm": "🗑 Վստա՞հ ես, որ ուզում ես ջնջել այս մեքենան:",
  "total": "Ընդհանուր",
  "gazels": "Գազելներ",
  "zils": "Զիլեր",
  "search_placeholder": "Որոնել (Անուն, համարանիշ...)",
  "add_car": "Ավելացնել Մեքենա",
  "image": "Նկար",
  "name_type": "Անվանում / Տեսակ",
  "parameters": "Պարամետրեր",
  "plate_number": "Համարանիշ",
  "driver": "Վարորդ",
  "action": "Գործողություն",
  "no_image": "Նկար չկա",
  "unit_ton": "տ",
  "unit_m3": "մ³",
  "unit_m": "մ",
  "edit_title": "Խմբագրել",
  "label_display_name": "Ցուցադրվող Անուն",
  "label_weight": "Քաշ",
  "label_volume": "Ծավալ",
  "label_length": "Երկարություն",
  "label_plate": "Համարանիշ",
  "save": "Պահպանել",
  "cancel": "Չեղարկել",
  "access_denied_relogin": "Մուտքը արգելված է: Խնդրում ենք վերամտնել համակարգ:",
  "enter_answer_error": "Մուտքագրեք պատասխանը",
  "error": "Սխալ",
  "train_failed": "Չհաջողվեց սովորեցնել",
  "delete_knowledge_confirm": "Վստա՞հ եք, որ ուզում եք ջնջել այս գիտելիքը:",
  "unanswered_count": "Անպատասխան",
  "knowledge_count": "Գիտելիքներ",
  "bot_status": "Կարգավիճակ",
  "status_active": "Ակտիվ",
  "tab_training": "Ուսուցում",
  "tab_database": "Շտեմարան",
  "refresh": "Թարմացնել",
  "all_questions_answered": "Բոլոր հարցերը պատասխանված են ✨",
  "write_answer_placeholder": "Գրեք պատասխանը...",
  "btn_train": "Սովորեցնել",
  "table_question": "Հարց",
  "table_answer": "Պատասխան",
  "table_action": "Գործողություն",
  "database_empty": "Շտեմարանը դատարկ է",


"cleaning_calc": {
  "step_1_title": "Ընտրեք ծառայությունը",
  "general": "Ընդհանուր",
  "partial": "Մասնակի",
  "hourly": "Ժամավճար",
  "dry_cleaning": "Քիմ մաքրում",
  "standard": "Ստանդարտ",
  "general_type": "Գեներալ",
  "renovation": "Վերանորոգում",
  "sqm": "քմ",
  "people": "հոգի",
  "hours": "ժամ",
  "continue": "Շարունակել ➡️",
  "step_2_title": "Լրացուցիչ մանրամասներ",
  "windows": "Պատուհաններ",
  "shelves": "Պահարանների ներս",
  "kitchen_tech": "Խոհանոցային տեխնիկա",
  "fridge": "Սառնարան",
  "oven": "Ջեռոց",
  "hood": "Օդաքարշ",
  "dishwasher": "Սպասք",
  "back": "Հետ",
  "next": "Հաջորդը",
  "step_3_title": "Պարագաներ",
  "vacuum": "Փոշեկուլ",
  "steam": "Գոլորշու մեքենա",
  "materials": "Նյութեր",
  "calculate": "ՀԱՇՎԱՐԿԵԼ",
  "result_title": "Պատվերի հաշվարկ",
  "total_price": "ԸՆԴՀԱՆՈՒՐ ՎՃԱՐ",
  "worker_count": "Աշխատակիցների քանակ",
  "edit_data": "ՓՈՓՈԽԵԼ ՏՎՅԱԼՆԵՐԸ",
  "error": "Հաշվարկի սխալ"
},

  "session_expired_error": "Ձեր մուտքի ժամկետը սպառվել է կամ դուք չունեք թույլտվություն:",
  "delete_faq_confirm": "Ջնջե՞լ այս հարցը 🗑️:",
  "faq_count_label": "Հարցերի քանակ",
  "faq_status_label": "Կարգավիճակ",
  "faq_status_published": "Հրապարակված",
  "edit_faq_title": "Խմբագրել FAQ",
  "add_faq_title": "Ավելացնել նոր FAQ",
  "faq_question_label": "Հարցը",
  "faq_question_placeholder": "Օրինակ՝ Ինչպե՞ս գրանցվել...",
  "faq_answer_label": "Պատասխանը",
  "faq_answer_placeholder": "Մանրամասն նկարագրեք պատասխանը...",
  "btn_update": "Թարմացնել",
  "btn_save": "Պահպանել",
  "existing_faqs_title": "Գոյություն ունեցող հարցեր",
  "table_question": "Հարց",
  "table_answer": "Պատասխան",
  "table_action": "Գործողություն",
  "btn_reply": "Պատասխանել",
  "reply_modal_title": "Պատասխանել նամակին",
  "reply_placeholder": "Գրեք Ձեր պատասխանը...",
  "btn_send_reply": "Ուղարկել Պատասխանը",
  "sending_loader": "Ուղարկվում է...",
  "reply_sent_success": "✅ Պատասխանը ուղարկվեց",
  "error_missing_id": "Սխալ. Նամակի ID-ն բացակայում է",
  "error_empty_reply": "Խնդրում ենք գրել պատասխանը",
  "server_error": "Սերվերի սխալ",
  "connection_error": "Կապի սխալ սերվերի հետ",
  "stats_total_messages": "Ընդհանուր նամակներ",
  "stats_today_messages": "Այսօր ստացված",
  "stats_with_files": "Ֆայլերով",
  "status_active": "Ակտիվ",
  "inbox_title": "Մուտքային Նամակներ",
  "badge_replied": "Պատասխանված",
  "view_file": "Դիտել ֆայլը",
  "customer_card": "Հաճախորդի քարտ",
  "label_phone": "Հեռախոս",
  "label_user_id": "User ID",
  "label_date": "Ամսաթիվ",
  "not_specified": "Նշված չէ",
  "guest_user": "Հյուր",
  "delete_message_confirm": "🗑 Ջնջե՞լ այս նամակը:",
  "delete_failed": "Ջնջումը չհաջողվեց",
  "notification_center_title": "Ծանուցումների Կենտրոն",
  "new_message_title": "Նոր Հաղորդագրություն",
  "label_send_to": "Ում ուղարկել",
  "option_all_users": "Բոլոր օգտատերերին",
  "label_title": "Վերնագիր",
  "placeholder_title": "Օրինակ՝ Շտապ առաջարկ...",
  "label_message": "Հաղորդագրություն",
  "placeholder_message": "Գրեք բովանդակությունը այստեղ...",
  "btn_send_notification": "Ուղարկել Ծանուցումը",
  "recent_activities_title": "Վերջին Գործողություններ",
  "history_empty": "Պատմությունը դատարկ է",
  "label_users": "Օգտատերեր",
  "label_total_sent": "Ընդհանուր Ուղարկված",
  "label_today": "Այսօր",
  "notification_sent_success": "✅ Ծանուցումը հաջողությամբ ուղարկվեց",
  "error_fill_fields": "Լրացրեք բոլոր դաշտերը",
  "error_sending": "Սխալ ուղարկելիս",
  "admin_orders_title": "Պատվերների Կառավարում",
  "calculator_not_available": "Հաշվիչը հասանելի չէ",
  "btn_close": "Փակել",
  "confirm_remove_worker": "Հաստատո՞ւմ եք հեռացումը:",
  "price_change_prefix": "Գնի փոփոխություն",
  "recalculation_sent_success": "Վերահաշվարկը հաջողությամբ ուղարկվեց",
  "error_token_missing": "Մուտքի թոքենը բացակայում է: Խնդրում ենք նորից մուտք գործել:",
  "order_closed_success": "Պատվերը հաջողությամբ փակվեց և հաշվարկվեց ✅",
  "backend_error_prefix": "Սերվերի սխալ",
  "unknown_error": "Անհայտ սխալ",
  "network_error": "Ցանցային սխալ: Ստուգեք կապը սերվերի հետ:",
  "filter_all": "Բոլորը",
  "filter_new": "Նոր",
  "filter_processing": "Մշակվում է",
  "filter_pending": "Սպասում է",
  "filter_confirmed": "Հաստատված",
  "filter_problem": "Խնդիր",
  "filter_modified": "Փոփոխված",
  "filter_in_progress": "Ընթացք",
  "filter_waiting_finish": "Ավարտի սպասող",
  "filter_finished": "Ավարտված",
  "filter_cancelled": "Չեղարկված",
  "btn_see_next_10": "Տեսնել հաջորդ 10-ը",
  "remaining_suffix": "մնաց",
  "total_projects": "Ընդհանուր Նախագծեր",
  "status_label": "Կարգավիճակ",
  "status_active": "Ակտիվ",
  "add_project_title": "Ավելացնել Նոր Նախագիծ",
  "edit_project_title": "Խմբագրել Նախագիծը",
  "project_name_label": "Նախագծի անվանում",
  "project_name_placeholder": "Օրինակ՝ Modern House Design",
  "images_label": "Նկարներ",
  "upload_images_hint": "Կտտացրեք նկարներ բեռնելու համար",
  "files_selected_suffix": "նկար ընտրված է",
  "description_label": "Նկարագրություն",
  "description_placeholder": "Նկարագրեք նախագծի մանրամասները...",
  "btn_save": "Պահպանել",
  "btn_update": "Թարմացնել",
  "btn_publish": "Հրապարակել",
  "btn_processing": "Մշակվում է...",
  "btn_cancel": "Չեղարկել",
  "projects_list_title": "Նախագծերի Ցուցակ",
  "table_col_image": "Նկար",
  "table_col_name": "Անվանում",
  "table_col_description": "Նկարագրություն",
  "table_col_actions": "Գործողություն",
  "confirm_delete_project": "Ջնջե՞լ այս նախագիծը 🗑️:",
  "error_session_expired": "Ձեր սեսիան ավարտվել է: Խնդրում ենք նորից մուտք գործել:",
  "error_access_denied": "Գործողությունը մերժված է: Մուտք գործեք համակարգ:",
"reviews_analytics_title": "Կարծիքներ",
  "rating_analytics_title": "Վարկանիշ",
  "today_analytics_title": "Այսօր",
  "admin_reviews_main_title": "Կարծիքների Կառավարում",
  "no_reviews_yet": "Կարծիքներ դեռ չկան",
  "anonymous_user": "Անանուն",
  "view_user_data_tooltip": "Տեսնել յուզերի տվյալները",
  "confirm_delete_review": "Ջնջե՞լ այս կարծիքը 🗑️:",
  "guest_badge": "Guest",
  "verified_reviewer_badge": "Verified Reviewer",
  "label_phone": "Հեռախոս",
  "label_user_id": "User ID",
  "label_registration_date": "Գրանցման ամսաթիվ",
  "not_specified": "Նշված չէ",
  "n_a": "N/A",
  "ana_services": "Ծառայություններ",
  "ana_categories": "Կատեգորիաներ",
  "add_service": "Ավելացնել Նոր Ծառայություն",
  "edit_service": "Խմբագրել Ծառայությունը",
  "label_category": "Կատեգորիա",
  "label_service_name": "Ծառայության անվանում",
  "label_price": "Գին (AMD)",
  "label_image": "Նկար",
  "label_description": "Նկարագրություն",
  "placeholder_service_name": "Օրինակ՝ Լազերային կտրում",
  "placeholder_price": "Օրինակ՝ 5000",
  "placeholder_description": "Ծառայության մանրամասն նկարագրությունը...",
  "select_option": "Ընտրել...",
  "upload_image": "Վերբեռնել նկար",
  "btn_save": "Պահպանել",
  "btn_update": "Թարմացնել",
  "btn_processing": "Մշակվում է...",
  "active_services_title": "Գործող Ծառայություններ",
  "table_image": "Նկար",
  "table_service": "Ծառայություն",
  "table_category": "Կատեգորիա",
  "table_price": "Գին",
  "table_actions": "Գործողություն",
  "price_negotiable": "Պայմ.",
  "no_data": "Տվյալներ չկան",
  "confirm_delete_service": "Ջնջե՞լ այս ծառայությունը 🗑️:",
  "error_session_expired": "Ձեր սեսիան ավարտվել է: Խնդրում ենք նորից մուտք գործել:",
  "tab_slides": "Սլայդներ",
  "tab_categories": "Կատեգորիաներ",
  "tab_partners": "Գործընկերներ",
  "tab_posts": "Գրառումներ",
  "total_label": "Ընդհանուր",
  "unit_count": "միավոր",
  "status_label": "Կարգավիճակ",
  "status_active": "Ակտիվ",
  "edit_label": "Խմբագրել",
  "add_new_label": "Ավելացնել նոր",
  "placeholder_title": "Վերնագիր",
  "placeholder_description": "Նկարագրություն",
  "placeholder_name": "Անվանում",
  "placeholder_icon_class": "Icon դաս (օրինակ՝ fa-star)",
  "placeholder_partner_name": "Գործընկերոջ անունը",
  "selected_label": "Ընտրված է",
  "click_to_upload": "Սեղմեք նկար ընտրելու համար",
  "btn_save": "Պահպանել",
  "btn_update": "Թարմացնել",
  "btn_processing": "Մշակվում է...",
  "table_image": "Նկար",
  "table_info": "Տեղեկություն",
  "table_actions": "Գործողություն",
  "confirm_delete": "Հաստատե՞լ ջնջումը 🗑️",
"tab_about": "Մեր մասին",
  "tab_contacts": "Կոնտակտային տվյալներ",
  "manage_info_subtitle": "Կառավարեք կայքի հիմնական տեղեկատվությունը",
  "loading": "Բեռնվում է...",
  "label_content_hy": "Բովանդակություն (Armenian)",
  "label_content_ru": "Բովանդակություն (Russian)",
  "placeholder_about": "Նկարագրեք ձեր ընկերությունը...",
  "label_phone": "Հեռախոս",
  "label_email": "Էլ. հասցե",
  "label_address": "Հասցե",
  "label_socials": "Սոցիալական ցանցեր",
  "btn_saving": "Պահպանվում է...",
  "btn_save_all": "Պահպանել բոլոր փոփոխությունները",
  "alert_success": "Փոփոխությունները հաջողությամբ պահպանվեցին ✨",
  "alert_session_expired": "Ձեր սեսիան ավարտվել է: Խնդրում ենք նորից մուտք գործել:",
  "alert_error_save": "Տեղի է ունեցել սխալ պահպանման ընթացքում:",
  "alert_conn_error": "Կապի սխալ սերվերի հետ:",
"users_center_title": "Օգտատերերի Կենտրոն",
  "users_center_subtitle": "Համակարգի բոլոր յուզերների լիարժեք վերահսկողություն",
  "stat_total": "Ընդհանուր",
  "stat_total_balance": "Ընդհանուր Բալանս",
  "stat_active": "Ակտիվ",
  "stat_blocked": "Բլոկված",
  "search_placeholder": "Որոնել ",
  "btn_refresh_list": "Թարմացնել ցուցակը",
  "loading": "Բեռնվում է...",
  "col_user": "Օգտատեր",
  "col_contacts": "Կոնտակտներ",
  "col_balance": "Բալանս",
  "col_date": "Ամսաթիվ",
  "col_status": "Կարգավիճակ",
  "col_actions": "Գործողություն",
  "status_blocked": "Արգելափակված",
  "status_verified": "Վերիֆիկացված",
  "no_users_found": "Օգտատերեր չեն գտնվել",
  "confirm_block_user": "⚠️ Արգելափակե՞լ օգտատիրոջը:",
  "confirm_unblock_user": "✅ Ապաարգելափակե՞լ օգտատիրոջը:",
  "prompt_new_balance": "Մուտքագրեք նոր բալանսը:",
  "tooltip_bypay": "By-Pay կարգավիճակ",
  "tooltip_block": "Արգելափակել",
  "tooltip_unblock": "Ապաարգելափակել",
  "tooltip_view_profile": "Դիտել պրոֆիլը",
  "alert_error_auth_status": "Սխալ է տեղի ունեցել (404 կամ Auth error)",
  "alert_server_error": "Սխալ: Համոզվեք, որ սերվերը միացված է",
"day": "Օր",
  "month": "Ամիս",
  "year": "Տարի",
  "wallet_view_mode": "ԴԻՏՄԱՆ ՌԵԺԻՄ",
  "wallet_new_transaction": "ՆՈՐ ԳՈՐԾԱՐՔ",
  "wallet_admin_expense": "ԱԴՄԻՆ ԾԱԽՍ",
  "wallet_ph_income": "Մուտք",
  "wallet_ph_salary": "Աշխատավարձ (-)",
  "wallet_ph_expense": "Ծախս (-)",
  "wallet_ph_amount": "Գումար (-)",
  "wallet_ph_desc": "Նպատակ...",
  "wallet_btn_register": "Գրանցել",
  "wallet_btn_reg_expense": "Ծախսը Գրանցել",
  "wallet_cash": "Կանխիկ",
  "wallet_online": "Online",
  "wallet_today": "Այսօր",
  "wallet_cash_income": "Կանխիկ Մուտք",
  "wallet_online_income": "Online Մուտք",
  "wallet_order_expense": "Պատվերի Ծախս",
  "wallet_other_expenses": "Այլ Ծախսեր",
  "wallet_itog_income": "Մուտքերի Itog",
  "wallet_salaries": "Աշխատավարձեր",
  "wallet_itog_expense": "Ծախսերի Itog",
  "wallet_net_profit": "Մաքուր Շահույթ",
  "wallet_search_ph": "Փնտրել ըստ նպատակի...",
  "wallet_all": "Բոլորը",
  "wallet_th_date": "ԱՄՍԱԹԻՎ",
  "wallet_th_income": "ՄՈՒՏՔ (+)",
  "wallet_th_salary": "ՌՈՃԻԿ (-)",
  "wallet_th_order_exp": "ԾԱԽՍ (-)",
  "wallet_th_admin_exp": "ԱՅԼ (-)",
  "wallet_th_profit": "ՇԱՀՈՒՅԹ",
  "wallet_th_desc": "ՆՊԱՏԱԿ",
  "wallet_th_tools": "ԳՈՐԾԻՔՆԵՐ",
  "wallet_delete_confirm": "🗑 Համոզվա՞ծ եք, որ ցանկանում եք ջնջել այս գործարքը:",
  "wallet_prompt_income": "Մուտքի Գումար (+):",
  "wallet_prompt_method": "Տեսակը (cash կամ online):",
  "wallet_prompt_salary": "Աշխատավարձ (-):",
  "wallet_prompt_order_exp": "Ծախս (-):",
  "wallet_prompt_admin_exp": "Այլ Ծախս (-):",
  "wallet_prompt_desc": "Նպատակ:",
"workers_title": "Աշխատակիցների կառավարում",
  "workers_subtitle": "Ֆինանսական վերահսկողություն և մոնիթորինգ",
  "workers_stat_total": "Ընդհանուր",
  "workers_stat_balance": "Ընդհանուր դրամապանակ",
  "workers_stat_low_balance": "Ցածր հաշվեկշիռ",
  "workers_stat_free": "Ազատ",
  "workers_stat_blocked": "Բլոկված",
  "workers_stat_rating": "Վարկանիշ",
  "workers_search_ph": "Որոնել անունով կամ մասնագիտությամբ...",
  "workers_filter_all": "Բոլորը",
  "workers_filter_free": "Ազատ",
  "workers_filter_busy": "Զբաղված",
  "workers_filter_blocked": "Բլոկված",
  "workers_th_staff": "Անձնակազմ",
  "workers_th_specialization": "Մասնագիտություն",
  "workers_th_balance": "Հաշվեկշիռ",
  "workers_th_status": "Կարգավիճակ",
  "workers_th_actions": "Գործողություն",
  "workers_default_spec": "Մասնագետ",
  "workers_status_blocked": "Բլոկված",
  "workers_status_free": "Ազատ",
  "workers_status_busy": "Զբաղված",
  "workers_label_phone": "Հեռախոս",
  "workers_label_address": "Հասցե",
  "workers_label_last_recharge": "Վերջին լիցքավորում",
  "workers_label_rating": "Ընդհանուր վարկանիշ",
  "workers_not_specified": "Նշված չէ",
  "workers_balance_error": "Հաշվեկշռի թարմացումը ձախողվեց",
  "workers_confirm_verify": "Հաստատե՞լ վարպետին:",
  "workers_confirm_unverify": "Չեղարկե՞լ հաստատումը:",
  "workers_confirm_block": "Արգելափակե՞լ:",
  "workers_confirm_unblock": "Ապաարգելափակե՞լ:",
  "stats_all": "Բոլորը",
  "stats_new": "Նոր",
  "stats_processing": "Մշակվում է",
  "stats_pending": "Սպասում է",
  "stats_confirmed": "Հաստատված",
  "stats_mismatch": "Խնդիր",
  "stats_modified": "Փոփոխված",
  "stats_in_progress": "Ընթացք",
  "stats_pending_finish": "Ավարտի սպասող",
  "stats_finished": "Ավարտված",
  "stats_cancelled": "Չեղարկված",
  "order_id": "ՊԱՏՎԵՐ",
  "customer_data": "ՀԱՃԱԽՈՐԴԻ ՏՎՅԱԼՆԵՐ",
  "no_name": "Անուն չկա",
  "order_details": "ՊԱՏՎԵՐԻ ՄԱՆՐԱՄԱՍՆԵՐ",
  "note": "Նշում",
  "no_additional_data": "Լրացուցիչ տվյալներ չկան",
  "total_amount": "ԸՆԴՀԱՆՈՒՐ ԳՈՒՄԱՐ",
  "workers": "ԱՇԽԱՏՈՂՆԵՐ",
  "no_workers": "Աշխատող չկա",
  "car": "Մեքենա",
  "specialist": "Վարպետ",
  "driver": "Վարորդ",
  "time_remaining": "ՄՆԱՑԵԼ Է",
  "delay": "ՈՒՇԱՑՈՒՄ",
  "btn_accept": "ԸՆԴՈՒՆԵԼ",
  "btn_confirm": "ՀԱՍՏԱՏԵԼ",
  "btn_confirm_order": "ՀԱՍՏԱՏԵԼ ՊԱՏՎԵՐԸ",
  "btn_match": "ՀԱՄԱՊԱՏԱՍԽԱՆՈՒՄ Է",
  "btn_issue": "ԽՆԴԻՐ",
  "btn_confirm_finish": "ՀԱՍՏԱՏԵԼ ԱՎԱՐՏԸ",
  "btn_continue_old_price": "ՇԱՐՈՒՆԱԿԵԼ (ՀԻՆ ԳՆՈՎ)",
  "btn_recalculate": "ՎԵՐԱՀԱՇՎԱՐԿԵԼ (ՀԱՇՎԻՉ)",
  "btn_finish": "ԱՎԱՐՏԵԼ",
  "btn_change_in_progress": "ՓՈՓՈԽԵԼ ԸՆԹԱՑՔՈՒՄ",
  "btn_reject": "ՄԵՐԺԵԼ / ՉԵՂԱՐԿԵԼ",
  "confirm_worker_remove": "Հաստատու՞մ եք վարպետի հեռացումը պատվերից:",
  "status_new": "ՆՈՐ ՊԱՏՎԵՐ",
  "status_processing": "ՄՇԱԿՄԱՆ ՄԵՋ",
  "status_pending": "ՍՊԱՍՈՒՄ Է",
  "status_confirmed": "ՀԱՍՏԱՏՎԱԾ",
  "status_mismatch": "ԽՆԴԻՐ / SOS",
  "status_modified": "ՓՈՓՈԽՎԱԾ",
  "status_in_progress": "ԸՆԹԱՑՔԻ ՄԵՋ",
  "status_pending_finish": "ԱՎԱՐՏԻ ՀԱՍՏԱՏՈՒՄ",
  "status_finished": "ԱՎԱՐՏՎԱԾ",
  "status_cancelled": "ՉԵՂԱՐԿՎԱԾ",
  "id_label": "ՊԱՏՎԵՐ #",
    "total_price": "ԸՆԴՀԱՆՈՒՐ ԳՈՒՄԱՐ",
    "car": "🚛 Մեքենա",
    "worker": "👨‍🔧 Վարպետ",
    "customer": "ՀԱՃԱԽՈՐԴԻ ՏՎՅԱԼՆԵՐ",
    "details": "ՊԱՏՎԵՐԻ ՄԱՆՐԱՄԱՍՆԵՐ",
    "workers": "ԱՇԽԱՏՈՂՆԵՐ",
    "accept": "ԸՆԴՈՒՆԵԼ",
    "confirm": "✅ ՀԱՍՏԱՏԵԼ",
    "confirm_order": "ՀԱՍՏԱՏԵԼ ՊԱՏՎԵՐԸ",
    "match": "ՀԱՄԱՊԱՏԱՍԽԱՆՈՒՄ է",
    "problem": "ԽՆԴԻՐ",
    "confirm_finish": "ՀԱՍՏԱՏԵԼ ԱՎԱՐՏԸ",
    "continue_old": "✅ ՇԱՐՈՒՆԱԿԵԼ (ՀԻՆ ԳՆՈՎ)",
    "recalculate": "🔄 ՎԵՐԱՀԱՇՎԱՐԿԵԼ",
    "finish": "ԱՎԱՐՏԵԼ",
    "change_progress": "ՓՈՓՈԽԵԼ ԸՆԹԱՑՔՈՒՄ",
    "reject": "ՄԵՐԺԵԼ / ՉԵՂԱՐԿԵԼ",
    "m": "ր",
    "s": "վ",
    "remove_worker": "Հաստատու՞մ եք վարպետի հեռացումը պատվերից:",
    "no_worker": "👤 Աշխատող չկա",
    "note": "Նշում",
    "reason_prompt": "Պատճառը:",
    "wallet": {
  "title": "Քսակ",
  "view_mode": "ԴԻՏՄԱՆ ՌԵԺԻՄ",
  "day": "Օր",
  "month": "Ամիս",
  "year": "Տարի",
  "new_transaction": "ՆՈՐ ԳՈՐԾԱՐՔ",
  "income": "Մուտք",
  "cash": "Կանխիկ",
  "online": "Online",
  "salary_neg": "Աշխատավարձ (-)",
  "expense_neg": "Ծախս (-)",
  "btn_register": "Գրանցել",
  "admin_expense": "ԱԴՄԻՆ ԾԱԽՍ",
  "amount_neg": "Գումար (-)",
  "purpose_placeholder": "Նպատակ...",
  "btn_register_expense": "Ծախսը Գրանցել",
  "today": "Այսօր",
  "this_month": "Ամիս",
  "this_year": "Տարի",
  "cash_income": "Կանխիկ Մուտք",
  "online_income": "Online Մուտք",
  "order_expense_label": "Պատվերի Ծախս",
  "other_expenses_label": "Այլ Ծախսեր",
  "total_income_label": "Մուտքերի Itog",
  "salaries_label": "Աշխատավարձեր",
  "total_expenses_label": "Ծախսերի Itog",
  "net_profit_label": "Մաքուր Շահույթ",
  "search_placeholder": "Փնտրել ըստ նպատակի...",
  "all": "Բոլորը",
  "th_date": "ԱՄՍԱԹԻՎ",
  "th_income": "ՄՈՒՏՔ (+)",
  "th_salary": "ՌՈՃԻԿ (-)",
  "th_expense": "ԾԱԽՍ (-)",
  "th_other": "ԱՅԼ (-)",
  "th_profit": "ՇԱՀՈՒՅԹ",
  "th_purpose": "ՆՊԱՏԱԿ",
  "th_tools": "ԳՈՐԾԻՔՆԵՐ",
  "confirm_delete": "🗑 Համոզվա՞ծ եք, որ ցանկանում եք ջնջել այս գործարքը:",
  "prompt_income": "Մուտքի Գումար (+):",
  "prompt_method": "Տեսակը (cash կամ online):",
  "prompt_salary": "Աշխատավարձ (-):",
  "prompt_expense": "Ծախս (-):",
  "prompt_other_expense": "Այլ Ծախս (-):",
  "prompt_desc": "Նպատակ:",
  
        
}


        }
      },
      en: {
        translation: {
          "about_us": "About Us",
          "loading": "Loading...",
          "no_info_added": "Information has not been added yet.",
          "total_visits": "Total Visits",
          "unique_users": "Unique Users",
          "total_orders": "Total Orders",
          "site_analytics": "Site Analytics",
          "seo_title": "Liber Group | Next-Gen Digital Logistics Ecosystem",
  "seo_description": "Liber Group: Automated logistics platform in Yerevan. 7-in-1 services with online calculator and fixed prices.",
  "seo_keywords": "logistics, waste removal, online calculator, liber group",
  "hero_badge": "NEXT-GEN DIGITAL ECOSYSTEM",
  "auto_algorithm": "AUTOMATED ALGORITHM",
  "working_hours": "System operates 24/7",
  "hero_highlights": ["WASTE REMOVAL", "UNLOADING", "PROFESSIONAL CLEANING", "HANDYMAN SERVICES", "TRANSPORTATION", "SMART LOGISTICS"],
  "ecosystem_tag": "ECOSYSTEM",
  "booking_title_1": "BOOKING IN",
  "booking_title_2": "60 SECONDS",
  "step_1_label": "STAGE 01",
  "step_1_desc": "Enter data and get instant calculation",
  "step_2_label": "STAGE 02",
  "step_2_desc": "Online order management",
  "automated_note": "Fully automated process",
  "home_services_title": "Our Services",
  "professional_service": "Professional Service",
  "home_see_more": "See More",

          // Calculators Hub
          "online_calculators": "ONLINE CALCULATORS",
          "back_to_list": "BACK TO LIST",
          "calculate_btn": "CALCULATE",
          "order_now": "ORDER NOW",
          "calc_trash_removal": "Construction Waste & Junk Removal",
          "calc_moving": "Moving Services",
          "calc_master": "Handyman Service",
          "calc_demolition": "Demolition & Waste Removal",
          "calc_cleaning": "Cleaning Services",
          "calc_fura": "Truck Unloading",
          "calc_machinery": "Machinery Rental",

          "admin_analytics": "Analytics",
          "admin_workers": "Workers",
          "admin_users": "Users",
          "admin_wallet": "Wallet",
          "admin_orders": "Orders",
          "admin_assets": "Calculator Items",
          "admin_cars": "Cars",
          "admin_messages": "Messages",
          "admin_bot": "Bot Training",
          "admin_notifications": "Notifications",
          "admin_portfolio": "Projects",
          "admin_services": "Services",
          "admin_slides": "Slider",
          "admin_categories": "Categories",
          "admin_partners": "Partners",
          "admin_reviews": "Reviews",
          "admin_faq": "FAQ",
          "admin_about": "About Us",
          "admin_contacts": "Contacts",

          "admin_welcome": "Welcome back, please login",
          "username": "Username",
          "password": "Password",
          "login_btn": "LOGIN",
          "logout": "LOGOUT",

          "status_new": "NEW ORDER",
          "status_confirmed": "CONFIRMED",
          "status_finished": "FINISHED",
          "status_cancelled": "CANCELLED",
          "contact_us_title": "GET IN TOUCH",
          "contact_us_subtitle": "Choose the most convenient contact option",
          "call_button": "CALL NOW",
           "cancel_btn": "Cancel",
           "bot_welcome": "Hello! I am Liber Bot. How can I help you?",
"bot_placeholder": "Type your message...",
"bot_online": "Online",
"bot_error_response": "Sorry, I couldn't process the response.",
"bot_connection_error": "Connection error. Please try again later.",
"contact_back": "Back",
"contact_main_title": "CONTACT US",
"contact_tab_write": "Write",
"contact_tab_inbox": "Replies",
"contact_form_title": "Feedback Form",
"contact_label_name": "Name",
"contact_label_phone": "Phone",
"contact_label_subject": "Subject",
"contact_label_message": "Message",
"contact_subject_placeholder": "What is the inquiry about",
"contact_attach_image": "Attach photo",
"contact_file_selected": "Selected",
"contact_btn_send": "SEND MESSAGE",
"contact_sending": "Sending...",
"contact_success": "Sent successfully",
"contact_login_required": "Please log in first",
"contact_no_messages": "No messages yet",
"contact_reply_from": "Reply from Liber Group",
"contact_view_attachment": "View attachment",
"contact_delete_confirm": "Delete this message?",
"contact_default_subject": "Inquiry",
"faq_main_title": "Frequently Asked Questions",
"faq_q1": "How to place an order?",
"faq_a1": "Select a service, click the 'Order' button, and fill in your details.",
"faq_q2": "How long does it take for a specialist to arrive?",
"faq_a2": "After confirming the order, a specialist will arrive within 1 hour.",
"faq_q3": "Is there a warranty?",
"faq_a3": "Yes, we provide a quality guarantee for all our work.",
"fav_loading": "Loading...",
"fav_back": "Back",
"fav_title": "My Favorites",
"fav_subtitle": "The collection of services you liked",
"fav_empty_title": "The list is empty",
"fav_empty_text": "You don't have any favorite services yet.",
"fav_explore_btn": "Explore Services",
"fav_price_contract": "Contractual",
"footer_rights": "All rights reserved.",
"footer_company": "Company",
"footer_about": "About Us",
"footer_projects": "Projects",
"footer_terms": "Terms of Use",
"footer_contact": "Contact Us",
"nav_home": "Home",
"nav_services": "Services",
"nav_projects": "Projects",
"nav_about": "About Us",
"nav_contact": "Contact",
"nav_login": "LOGIN",
"nav_register": "REGISTER",
"nav_profile": "My Profile",
"nav_orders": "Orders",
"nav_favorites": "Favorites",
"nav_logout": "Logout",
"loading": "Loading...",
"home_hero_slogan": "PROFESSIONAL SERVICES",
"home_quick_contact": "QUICK CONTACT",
"home_services_title": "OUR SERVICES",
"home_card_badge": "FAST AND QUALITY",
"home_see_more": "SEE MORE",
"inv_prof_service": "Professional Cleaning Services",
"inv_title": "INVOICE",
"inv_number": "Number",
"inv_date": "Date",
"inv_from": "From",
"inv_company_name": "Liber Service LLC",
"inv_company_addr": "Yerevan, Armenia",
"inv_customer": "Customer",
"inv_dear_customer": "Valued Customer",
"inv_th_service": "Service",
"inv_th_qty": "Qty",
"inv_th_price": "Price",
"inv_total": "Total",
"inv_btn_download": "Download PDF",
"inv_btn_close": "Close",
"login_subtitle": "Log in to the system",
"login_username": "Username",
"login_username_placeholder": "Username",
"login_password": "Password",
"login_password_placeholder": "Password",
"login_btn_submit": "Login",
"login_btn_loading": "Logging in...",
"login_error_failed": "Login failed",
"login_error_server": "Server unreachable. Check connection.",
"nav_home": "HOME",
"nav_projects": "PROJECTS",
"nav_about": "ABOUT US",
"nav_favorites": "FAVORITES",
"nav_services": "SERVICES",
"nav_contact": "CONTACT",
"nav_login": "LOGIN",
"nav_profile": "MY PROFILE",
"nav_orders": "Order",
"admin_notifications": "Notifications",
"admin_partners": "PARTNERS",
"online_calculators": "CALCULATORS",
"home_see_more": "SEE ALL",
"contact_label_subject": "Subject",
"contact_label_message": "Message",
"contact_subject_placeholder": "Subject (ex. Discounts)",
"contact_btn_send": "Send to All",
"contact_sending": "Sending...",
"contact_success": "Notification sent successfully",
"contact_tab_inbox": "History",
"contact_no_messages": "History is empty",
"contact_delete_confirm": "Delete this history?",
"status_new": "New",
"status_pending": "Pending",
"status_completed": "Completed",
"bot_connection_error": "Connection error",
"bot_error_response": "Error",
"status_label": "Status",
"status_pending": "Pending",
"status_in_progress": "In Progress",
"status_completed": "Completed",
"status_cancelled": "Cancelled",
"notification_center_title": "Notification Center",
"login_required_notifs": "Please log in to see notifications",
"notif_type_global": "GLOBAL",
"notif_type_personal": "PERSONAL",
"order_finish_payment": "Finish & Payment",
"order_finish_subtitle": "Confirm and pay to close the order",
"payment_method_label": "Payment Method",
"payment_method_cash": "Cash",
"payment_method_online": "Online",
"payment_method_later": "Pay Later (Debt)",
"online_payment_instruction": "Transfer the amount and click confirm.",
"payment_comment_warning": "Write this code in the comment:",
"rate_master_label": "Rate the master",
"btn_confirm_transfer": "✅ I TRANSFERRED (CONFIRM)",
"btn_confirm_payment": "CONFIRM PAYMENT",
"price_change_title": "Price Change",
"price_change_subtitle": "Master suggests a new price",
"btn_agree": "I Agree",
"btn_reject": "Reject",
"floating_pay_waiting": "Order waiting for payment",
"floating_price_change": "Confirm price change",
"btn_copy": "Copy",
"copy_status_success": "Copied",
"btn_back": "Back",
"order_confirmation_title": "Confirmation",
"fill_required_fields": "Fill in required fields *",
"form_full_name": "Full Name",
"form_phone": "Phone",
"form_date": "Date",
"form_time": "Time",
"form_address": "Address",
"form_notes": "Notes",
"placeholder_name": "Name",
"placeholder_address": "Street, house...",
"placeholder_notes": "Additional info...",
"btn_confirm_order": "CONFIRM ORDER",
"gps_not_supported": "GPS not supported",
"location_fetch_error": "Could not fetch location",
"order_success_msg": "Order placed successfully ✅",
"order_failed_msg": "Failed to place order",
"error_label": "Error",
"default_service_name": "WASTE REMOVAL",
"partners_title_prefix": "Our",
  "partners_title_main": "Partners",
  "loading": "Loading",
  "no_partners": "No partners available",
  "portfolio_title_prefix": "Our",
  "portfolio_title_main": "Projects",
  "portfolio_subtitle": "Each project is a testament to our quality and professionalism",
  "portfolio_photo_count": "Photos",
  "no_projects": "No projects yet.",
  "loading": "Loading",
  "register_page_title": "Registration",
  "register_subtitle": "Create your account now",
  "form_full_name": "Full Name",
  "form_email": "Email Address",
  "form_phone": "Phone Number",
  "form_password": "Password",
  "form_confirm_password": "Confirm Password",
  "placeholder_name": "Aram Aramyan",
  "pass_hint_chars": "8+ characters",
  "pass_hint_number": "Number",
  "pass_hint_upper": "Uppercase",
  "error_pass_mismatch": "Passwords do not match",
  "btn_create_account": "Create Account",
  "already_have_account": "Already have an account?",
  "login_link": "Login",
  "register_success_alert": "Congratulations! Registration was successful.",
  "error_404_server": "Error. Server address not found (404).",
  "register_error_generic": "Registration error. Data is already in use.",
  "error_server_unavailable": "Server is unavailable. Check your connection.",
  "review_access_denied": "Access restricted",
"review_login_prompt": "Please log in to leave a review",
"alert_select_stars": "Please select a star rating",
"alert_write_review": "Please write your review",
"alert_relogin": "Please log in again",
"customer_default_name": "Customer",
"review_success_msg": "Review sent. Thank you ✅",
"review_error_msg": "Failed to send review",
"error_server_connection": "Server connection error",
"review_form_title": "Leave a review",
"review_form_subtitle": "Your opinion matters to us",
"placeholder_review_text": "How would you rate the service provided...",
"btn_sending": "Sending...",
"btn_send_review": "Send Review",
"review_anonymous": "Anonymous",
"search_placeholder": "Search for service...",
"alert_login_to_review": "Log in to leave a review:",
"alert_write_text": "Please write your review:",
"review_sent_success": "✅ Review sent",
"error_generic": "An error occurred",
"service_not_found": "Service not found",
"seo_description_suffix": "in Yerevan: Fast calculation and quality service.",
"btn_back": "Back",
"reviews_count_label": "reviews",
"order_guide_title": "Ordering Guide",
"step_1_title": "Calculate",
"step_1_desc": "Click 'Calculate Price' and go to the calculator",
"step_2_title": "Order",
"step_2_desc": "Confirm the calculation and place your order",
"info_guarantee": "100% Guarantee",
"info_fast_service": "Fast Service",
"cta_ready_to_calc": "Ready to calculate?",
"btn_calculate_price": "Calculate Price",
"customer_reviews_title": "Customer Reviews",
"placeholder_write_review": "Leave your review here...",
"btn_send": "Send",
"no_reviews_yet": "No reviews yet",
"reviews_count_label": "reviews",
"description_title": "Description",
"no_description_available": "A detailed description for this service has not been added yet.",
"btn_order_now": "ORDER NOW",
"customer_reviews_title": "Customer Reviews",
"placeholder_write_review": "Leave your review...",
"btn_send": "Send",
"example_reviewer_name": "Armen Gevorgyan",
"example_review_text": "Very good and high-quality service, I recommend it.",
"social_share_title": "Join us and share the site",
"share_nav_text": "Quality construction and modern solutions",
"alert_link_copied": "Link copied to clipboard.",
"btn_share": "Share",
"no_services_found_in_category": "No services found in '{{category}}' category",
"back_to_home": "Back to Home",
"price_on_request": "Price on request",
"view_details": "View details",
"login_page_title": "Login",
"login_subtitle": "Log in to continue",
"label_email_or_phone": "Email or Phone",
"placeholder_login_input": "Enter your credentials",
"label_password": "Password",
"link_forgot_password": "Forgot?",
"btn_login": "Log In",
"no_account_text": "Don't have an account?",
"link_register": "Register",
"error_phone_short": "Phone number must be at least 9 digits",
"error_password_short": "Password must be at least 6 characters",
"error_login_failed": "Login failed",
"error_server_connection": "Server connection error",
"terms_title": "Terms of Use",
"last_updated": "Last updated:",
"loading": "Loading...",
"btn_back": "Back",
"terms_sec1_title": "1. General Provisions",
"terms_sec1_text": "Welcome to the Liber Group website. By using our site, you agree to these terms.",
"terms_sec2_title": "2. Provision of Services",
"terms_sec2_text": "All services presented on the site are for informational purposes. Each order is formalized by a separate contract.",
"terms_sec3_title": "3. Privacy",
"terms_sec3_text": "The personal data provided by you is used exclusively to contact you.",
  "my_profile_btn": "MY PROFILE",
  "login_btn": "LOGIN",
  "contact_btn": "CONTACT",
  "notifications_header": "NOTIFICATIONS",
  "notif_order_label": "Order",
  "notif_info": "Information",
  "notif_announcement": "Announcement",
  "no_new_notifications": "No new notifications",
  "see_all_notifications": "SEE ALL",
  "nav_home": "HOME",
  "nav_projects": "PROJECTS",
  "nav_about": "ABOUT US",
  "nav_favorites": "FAVORITES",
  "nav_services": "SERVICES",
  "nav_partners": "PARTNERS",
  "nav_calculators": "CALCULATORS",
  "nav_contact": "CONTACT",
    "back_to_profile": "Back to profile",
    "filter_current": "Current",
    "filter_completed": "Completed",
    "filter_cancelled": "Cancelled",
    "orders_count": "orders",
    "loading": "Loading...",
    "no_orders": "No orders in this section",
    "no_address": "Address not specified",
    "total_price": "Total:",
    "currency": "AMD",
    "btn_pay": "PAY NOW",
    "btn_invoice": "Invoice",
    "btn_cancel": "Cancel",
    "login_required": "Please log in:",
    "rating_done": "Your rating",
    "rating_ask": "How would you rate the work?",
    "cancel_confirm": "Are you sure you want to cancel this order?",
    "cancel_success": "✅ Order cancelled successfully",
    "cancel_error": "🚨 Error during cancellation",
    "review_success": "Thank you for your rating ✅",
    "review_error": "Failed to save the rating:",
    "connection_error": "Connection error: Socket unavailable:",
      "new": "New",
      "processing": "Processing",
      "confirmed": "Confirmed",
      "arrived": "In Progress",
      "pending_finish": "Awaiting Approval",
      "finished": "Completed",
      "cancelled": "Cancelled",
      "title": "PROFILE",
    "role_worker": "SPECIALIST",
    "role_customer": "CUSTOMER",
    "tab_orders": "ORDERS",
    "tab_info": "INFO",
    "tab_settings": "SETTINGS",
    "recent_orders": "RECENT ORDERS",
    "order_id": "Order",
    "loading": "Loading...",
    "no_orders": "No orders found",
    "see_all": "SEE ALL",
    "full_name": "FULL NAME",
    "email": "EMAIL ADDRESS",
    "phone_1": "PHONE 1",
    "phone_2": "PHONE 2",
    "address": "ADDRESS",
    "save_changes": "SAVE CHANGES",
    "notifications": "NOTIFICATIONS",
    "email_notify": "Email notifications",
    "sms_notify": "SMS notifications",
    "reg_date": "Registration date",
    "logout": "LOGOUT",
    "update_success": "Information updated successfully",
    "update_error": "Error updating information",
    "missing_data": "User data is missing",
    "conn_error": "Connection error with server",
  "back_to_profile": "Back to Profile",
  "tab_current": "Current",
  "tab_completed": "Completed",
  "tab_cancelled": "Cancelled",
  "orders_count": "order(s)",
  "loading": "Loading",
  "no_orders_in_section": "No orders in this section",
  "no_address": "Address not specified",
  "your_rating": "Your rating",
  "rate_work": "How would you rate the work?",
  "total_price_label": "Total",
  "btn_pay": "PAY",
  "admin": {
    "calculator_management": "Calculator Management",
    "new_calculator": "New Calculator",
    "navbars": "Navbars",
    "add_navbar": "Add Navbar",
    "groups": "Groups",
    "add_group": "Add Group",
    "group_name": "Group Name",
    "asset_list": "Asset List",
    "add_new_asset": "Add New Asset",
    "calculator_settings": "Calculator Settings",
    "name": "Name",
    "icon": "Icon",
    "factor": "Factor",
    "weight": "Weight",
    "volume": "Volume",
    "volume_m3": "Volume (m³)",
    "unit": "Unit",
    "unit_m2": "sq.m",
    "unit_gmetr": "linear meter",
    "unit_hat": "pcs",
    "unit_m3": "m³",
    "price": "Price",
    "actions": "Actions",
    "elevator": "Elevator",
    "fits_elevator": "Fits in elevator",
    "no_elevator": "Does not fit",
    "h": "h",
    "min_hours": "Min Hours",
    "extra_price_hr": "Extra $/hr",
    "key": "Key",
    "ton": "Ton",
    "tech": "Equipment",
    "wood": "Wood",
    "pallet": "Pallet",
    "big_box": "Big Box",
    "front_id": "Frontend ID",
    "density": "Density",
    "group": "Group",
    
    "min_order_price": "Min Order Price",
    "base_weight": "Base Weight",
    "base_volume": "Base Volume",
    "price_per_km": "Price per KM",
    "free_distance": "Free Distance",
    "elevator_fee": "Elevator Fee",
    "stairs_fee": "Stairs Fee",
    "discounts_json": "Discounts Config (JSON)",
    "name_required": "Name is required",
    "add_failed": "Addition failed",
    "missing_edit_data": "Missing edit data",
    "endpoint_not_found": "Endpoint not found",
    "select_calculator_first": "Select a calculator first",
    "limit_reached": "Limit reached"
  },
  "common": {
    "add": "Add",
    "save_changes": "Save Changes",
    "saving": "Saving...",
    "updated_successfully": "Updated successfully",
    "update_error": "Update error",
    "saved_successfully": "Saved successfully",
    "save_error": "Save error",
    "are_you_sure": "Are you sure?",
    "delete_error": "Delete error"
  },
  "btn_invoice": "Invoice",
  "btn_cancel": "Cancel",
  "alert_socket_error": "Connection error. Socket is unavailable:",
  "customer_default_name": "Customer",
  "rating_for_order": "Rating for order",
  "alert_rating_success": "Thank you for your rating ✅",
  "alert_rating_error": "Failed to save the rating:",
  "confirm_cancel_order": "Are you sure you want to cancel this order?",
  "alert_cancel_success": "✅ Order successfully cancelled",
  "alert_cancel_error": "🚨 Error during cancellation",
  "back_btn": "Back",
  "reviews_count": "reviews",
  "price_from": "Price starting from",
  "order_now_btn": "Order Now",
  "customer_reviews_title": "Customer Reviews",
  "no_reviews_yet": "There are no reviews for this service yet. Be the first!",
  "service_not_found": "Service not found",
  "return_home": "Back to Home",
  "alert_cancel_success": "✅ Order successfully cancelled",
  "alert_cancel_error": "🚨 Error during cancellation",
  "back_btn": "Back",
  "reviews_count": "reviews",
  "price_from": "Price starting from",
  "order_now_btn": "Order Now",
  "customer_reviews_title": "Customer Reviews",
  "no_reviews_yet": "There are no reviews for this service yet. Be the first!",
  "service_not_found": "Service not found",
  "return_home": "Back to Home",
  "back_to_profile": "Back to Profile",
  "tab_current": "Current",
  "tab_completed": "Completed",
  "tab_cancelled": "Cancelled",
  "orders_count": "orders",
  "loading": "Loading",
  "no_orders_in_section": "No orders in this section",
  "no_address": "No address specified",
  "rate_work": "Rate the work",
  "your_rating": "Your rating",
  "total_price_label": "Total Price",
  "btn_pay": "Confirm & Pay",
  "btn_invoice": "Invoice",
  "btn_cancel": "Cancel",
  "please_login": "Please login to continue",
  "status_new": "New",
  "status_processing": "Processing",
  "status_confirmed": "Confirmed",
  "status_arrived": "Arrived",
  "status_pending_pay": "Pending Payment",
  "status_finished": "Finished",
  "status_cancelled": "Cancelled",
  "alert_socket_error": "Connection error. Please try again.",
  "alert_rating_success": "Thank you for your rating!",
  "alert_rating_error": "Error while rating.",
  "confirm_cancel_order": "Are you sure you want to cancel this order?",
  "customer_default_name": "Customer",
  "rating_for_order": "Rating for order",
  "view_all_orders": "VIEW ALL",
  "address_label": "Address",
  "address_placeholder": "Enter address...",
  "floor_label": "Floor",
  "elevator_label": "Elevator",
  "elevator_none": "None",
  "elevator_small": "Passenger",
  "elevator_large": "Freight",
  "calculate_btn": "CALCULATE",
  "new_calc_btn": "NEW CALCULATION",
  "select_item_alert": "Please select at least one item",
  "address": "📍 Address",
  "floor": "🏢 Floor",
  "elevator": "🛗 Elevator",
  "items_list": "📦 Items List",
  "selected_items": "Selected Items",
  "summary": "🚛 Summary",
  "not_specified": "Not specified",
  "error": "Calculation error",
  "single_address": "Single address",
"need_packing": "Packing",
"need_truck": "Truck",
"search_placeholder": "Search item...",
"total_price": "Total price",
"master_title": "🛠 MASTER SERVICES",
"by_meter": "by meter",
"by_count": "by count",
"calculation_result": "Calculation Result",
"total": "Total:",
"back_btn": "GO BACK",
"meter_unit": "m",
"demolition_title": "DEMOLITION WORKS",
"address_placeholder_house": "Street, house...",
"elevator_none_short": "None",
"elevator_small_short": "Pass.",
"elevator_large_short": "Cargo",
"search_work": "Search work...",
"cm": "CM",
"modify": "MODIFY",
"select_work_alert": "Please select at least one work",
"select_cargo_type": "Select cargo type",
"no_data_found": "No data found in database",
"fill_hours_alert": "Please fill the number of hours",
"fill_qty_alert": "Please fill the quantity",
"qty_label": "Quantity",
"hours_label": "Number of hours",
"weight_label": "Total Weight (Ton)",
"distance_label": "Distance (Meter)",
"dist_placeholder": "0-10m free",
"back_to_menu": "Back to menu",
"calculation_ready": "Calculation is ready",
"total_sum": "TOTAL AMOUNT",
"cargo_type": "Cargo type",
"distance": "Distance",
"time": "Time",
"unit_m3": "m³",
"unit_pcs": "pcs",
"unit_ton": "t",
"unit_hour": "hr",
"unit_meter": "m",
"machinery_title": "Special Machinery",
"machinery_subtitle": "Select type and duration",
"min_hours": "minimum: {{count}} hours",
"selected_hours": "{{count}} hours",
"hour_quantity": "Duration",
"calculation_ready": "Calculation is ready",
"order_summary": "ORDER SUMMARY",
"total": "Total",
"machinery_label": "Machinery",
"calculate_btn": "CALCULATE",
"modify_btn": "MODIFY",
"calculation_error": "Calculation error",
"cleaning_calc": {
  "step_1_title": "Choose Service",
  "general": "General",
  "partial": "Partial",
  "hourly": "Hourly",
  "dry_cleaning": "Dry Cleaning",
  "standard": "Standard",
  "general_type": "General",
  "renovation": "Post-Construction",
  "sqm": "sqm",
  "people": "people",
  "hours": "hours",
  "continue": "Continue ➡️",
  "step_2_title": "Additional Details",
  "windows": "Windows",
  "shelves": "Inside Shelves",
  "kitchen_tech": "Kitchen Appliances",
  "fridge": "Fridge",
  "oven": "Oven",
  "hood": "Hood",
  "dishwasher": "Dishwasher",
  "back": "Back",
  "next": "Next",
  "step_3_title": "Tools & Supplies",
  "vacuum": "Vacuum Cleaner",
  "steam": "Steam Machine",
  "materials": "Materials",
  "calculate": "CALCULATE",
  "result_title": "Order Calculation",
  "total_price": "TOTAL PRICE",
  "worker_count": "Number of Staff",
  "edit_data": "EDIT DATA",
  "error": "Calculation Error"
},
"total_visits": "Total Visits",
    "unique_users": "Unique Users",
    "total_orders": "Total Orders",
    "site_analytics": "Site Analytics",
    "top_categories": "Top Categories",
    "top_subservices": "Top Sub-services",
    "search_frequency": "Search Frequency",
    "filter_placeholder": "Filter searches...",
    "category": "Category",
    "service": "Service",
    "views": "Views",
    "times": "times",
    "no_data": "No data available",
    "delete_confirm": "Delete this search history?",
    "loading": "Loading...",
  "delete_car_confirm": "🗑 Are you sure you want to delete this car?",
  "total": "Total",
  "gazels": "Gazelles",
  "zils": "Zils",
  "search_placeholder": "Search (Name, plate number...)",
  "add_car": "Add Car",
  "image": "Image",
  "name_type": "Name / Type",
  "parameters": "Parameters",
  "plate_number": "Plate Number",
  "driver": "Driver",
  "action": "Action",
  "no_image": "No Image",
  "unit_ton": "t",
  "unit_m3": "m³",
  "nav_blog": "Blog",
  "unit_m": "m",
  "edit_title": "Edit Car",
  "label_display_name": "Display Name",
  "label_weight": "Weight",
  "label_volume": "Volume",
  "label_length": "Length",
  "label_plate": "Plate Number",
  "save": "Save",
  "cancel": "Cancel",
  "access_denied_relogin": "Access denied. Please log in again.",
  "enter_answer_error": "Please enter an answer",
  "error": "Error",
  "train_failed": "Failed to train bot",
  "delete_knowledge_confirm": "Are you sure you want to delete this knowledge?",
  "unanswered_count": "Unanswered",
  "knowledge_count": "Knowledge Base",
  "bot_status": "Status",
  "status_active": "Active",
  "tab_training": "Training",
  "tab_database": "Database",
  "refresh": "Refresh",
  "all_questions_answered": "All questions are answered ✨",
  "write_answer_placeholder": "Write an answer...",
  "btn_train": "Train Bot",
  "table_question": "Question",
  "table_answer": "Answer",
  "table_action": "Action",
  "database_empty": "Database is empty",
  "session_expired_error": "Your session has expired or you do not have permission.",
  "delete_faq_confirm": "Delete this question? 🗑️",
  "faq_count_label": "Questions Count",
  "faq_status_label": "Status",
  "faq_status_published": "Published",
  "edit_faq_title": "Edit FAQ",
  "add_faq_title": "Add New FAQ",
  "faq_question_label": "Question",
  "faq_question_placeholder": "Example: How to register...",
  "faq_answer_label": "Answer",
  "faq_answer_placeholder": "Describe the answer in detail...",
  "btn_update": "Update",
  "btn_save": "Save",
  "existing_faqs_title": "Existing Questions",
  "table_question": "Question",
  "table_answer": "Answer",
  "table_action": "Action",
  "btn_reply": "Reply",
  "reply_modal_title": "Reply to message",
  "reply_placeholder": "Write your reply...",
  "btn_send_reply": "Send Reply",
  "sending_loader": "Sending...",
  "reply_sent_success": "✅ Reply sent successfully",
  "error_missing_id": "Error: Message ID is missing",
  "error_empty_reply": "Please write a reply",
  "server_error": "Server error",
  "connection_error": "Connection error with server",
  "stats_total_messages": "Total Messages",
  "stats_today_messages": "Received Today",
  "stats_with_files": "With Attachments",
  "status_active": "Active",
  "inbox_title": "Inbox Messages",
  "badge_replied": "Replied",
  "view_file": "View File",
  "customer_card": "Customer Card",
  "label_phone": "Phone",
  "label_user_id": "User ID",
  "label_date": "Date",
  "not_specified": "Not specified",
  "guest_user": "Guest",
  "delete_message_confirm": "🗑 Delete this message?",
  "delete_failed": "Deletion failed",
"notification_center_title": "Notification Center",
  "new_message_title": "New Message",
  "label_send_to": "Send to",
  "option_all_users": "All Users",
  "label_title": "Title",
  "placeholder_title": "Example: Flash Sale...",
  "label_message": "Message",
  "placeholder_message": "Write the content here...",
  "btn_send_notification": "Send Notification",
  "recent_activities_title": "Recent Activities",
  "history_empty": "History is empty",
  "label_users": "Users",
  "label_total_sent": "Total Sent",
  "label_today": "Today",
  "notification_sent_success": "✅ Notification sent successfully",
  "error_fill_fields": "Please fill all fields",
  "error_sending": "Error while sending",
"admin_orders_title": "Order Management",
  "calculator_not_available": "Calculator not available",
  "btn_close": "Close",
  "confirm_remove_worker": "Are you sure you want to remove this worker?",
  "price_change_prefix": "Price Change",
  "recalculation_sent_success": "Recalculation sent successfully",
  "error_token_missing": "Authorization token missing! Please log in again.",
  "order_closed_success": "Order successfully closed and calculated ✅",
  "backend_error_prefix": "Backend error",
  "unknown_error": "Unknown error",
  "network_error": "Network error: Please check your connection to the server.",
  "filter_all": "All",
  "filter_new": "New",
  "filter_processing": "Processing",
  "filter_pending": "Pending",
  "filter_confirmed": "Confirmed",
  "filter_problem": "Problem",
  "filter_modified": "Modified",
  "filter_in_progress": "In Progress",
  "filter_waiting_finish": "Waiting Finish",
  "filter_finished": "Finished",
  "filter_cancelled": "Cancelled",
  "btn_see_next_10": "See next 10",
  "remaining_suffix": "remaining",
  "total_projects": "Total Projects",
  "status_label": "Status",
  "status_active": "Active",
  "add_project_title": "Add New Project",
  "edit_project_title": "Edit Project",
  "project_name_label": "Project Name",
  "project_name_placeholder": "e.g. Modern House Design",
  "images_label": "Images",
  "upload_images_hint": "Click to upload images",
  "files_selected_suffix": "images selected",
  "description_label": "Description",
  "description_placeholder": "Describe the project details...",
  "btn_save": "Save",
  "btn_update": "Update",
  "btn_publish": "Publish",
  "btn_processing": "Processing...",
  "btn_cancel": "Cancel",
  "projects_list_title": "Projects List",
  "table_col_image": "Image",
  "table_col_name": "Name",
  "table_col_description": "Description",
  "table_col_actions": "Actions",
  "confirm_delete_project": "Are you sure you want to delete this project? 🗑️",
  "error_session_expired": "Your session has expired. Please log in again.",
  "error_access_denied": "Access denied. Please log in.",
"reviews_analytics_title": "Reviews",
  "rating_analytics_title": "Rating",
  "today_analytics_title": "Today",
  "admin_reviews_main_title": "Review Management",
  "no_reviews_yet": "No reviews yet",
  "anonymous_user": "Anonymous",
  "view_user_data_tooltip": "View user details",
  "confirm_delete_review": "Are you sure you want to delete this review? 🗑️",
  "guest_badge": "Guest",
  "verified_reviewer_badge": "Verified Reviewer",
  "label_phone": "Phone",
  "label_user_id": "User ID",
  "label_registration_date": "Registration Date",
  "not_specified": "Not specified",
  "n_a": "N/A",
"ana_services": "Services",
  "ana_categories": "Categories",
  "add_service": "Add New Service",
  "edit_service": "Edit Service",
  "label_category": "Category",
  "label_service_name": "Service Name",
  "label_price": "Price (AMD)",
  "label_image": "Image",
  "label_description": "Description",
  "placeholder_service_name": "e.g. Laser Cutting",
  "placeholder_price": "e.g. 5000",
  "placeholder_description": "Detailed description of the service...",
  "select_option": "Select...",
  "upload_image": "Upload Image",
  "btn_save": "Save",
  "btn_update": "Update",
  "btn_processing": "Processing...",
  "active_services_title": "Active Services",
  "table_image": "Image",
  "table_service": "Service",
  "table_category": "Category",
  "table_price": "Price",
  "table_actions": "Actions",
  "price_negotiable": "Negot.",
  "no_data": "No data available",
  "confirm_delete_service": "Delete this service? 🗑️",
  "error_session_expired": "Your session has expired. Please log in again.",
  "tab_slides": "Slides",
  "tab_categories": "Categories",
  "tab_partners": "Partners",
  "tab_posts": "Posts",
  "total_label": "Total",
  "unit_count": "units",
  "status_label": "Status",
  "status_active": "Active",
  "edit_label": "Edit",
  "add_new_label": "Add new",
  "placeholder_title": "Title",
  "placeholder_description": "Description",
  "placeholder_name": "Name",
  "placeholder_icon_class": "Icon class (e.g., fa-star)",
  "placeholder_partner_name": "Partner name",
  "selected_label": "Selected",
  "click_to_upload": "Click to upload image",
  "btn_save": "Save",
  "btn_update": "Update",
  "btn_processing": "Processing...",
  "table_image": "Image",
  "table_info": "Information",
  "table_actions": "Actions",
  "confirm_delete": "Confirm deletion? 🗑️",
  "tab_about": "About Us",
  "tab_contacts": "Contact Details",
  "manage_info_subtitle": "Manage basic website information",
  "loading": "Loading...",
  "label_content_hy": "Content (Armenian)",
  "label_content_ru": "Content (Russian)",
  "placeholder_about": "Describe your company...",
  "label_phone": "Phone",
  "label_email": "Email",
  "label_address": "Address",
  "label_socials": "Social Networks",
  "btn_saving": "Saving...",
  "btn_save_all": "Save All Changes",
  "alert_success": "Changes saved successfully ✨",
  "alert_session_expired": "Your session has expired. Please log in again.",
  "alert_error_save": "An error occurred while saving.",
  "alert_conn_error": "Connection error with the server.",
  "users_center_title": "Users Center",
  "users_center_subtitle": "Full control over all system users",
  "stat_total": "Total Users",
  "stat_total_balance": "Total Balance",
  "stat_active": "Active",
  "stat_blocked": "Blocked",
  "search_placeholder": "Search by name, ID, or phone...",
  "btn_refresh_list": "Refresh List",
  "loading": "Loading...",
  "col_user": "User",
  "col_contacts": "Contacts",
  "col_balance": "Balance",
  "col_date": "Date",
  "col_status": "Status",
  "col_actions": "Actions",
  "status_blocked": "Blocked",
  "status_verified": "Verified",
  "no_users_found": "No users found",
  "confirm_block_user": "⚠️ Are you sure you want to block this user?",
  "confirm_unblock_user": "✅ Are you sure you want to unblock this user?",
  "prompt_new_balance": "Enter the new balance:",
  "tooltip_bypay": "By-Pay Status",
  "tooltip_block": "Block User",
  "tooltip_unblock": "Unblock User",
  "tooltip_view_profile": "View Profile",
  "alert_error_auth_status": "An error occurred (404 or Auth error)",
  "alert_server_error": "Error: Make sure the server is running",
  "day": "Day",
  "month": "Month",
  "year": "Year",
  "wallet_view_mode": "VIEW MODE",
  "wallet_new_transaction": "NEW TRANSACTION",
  "wallet_admin_expense": "ADMIN EXPENSE",
  "wallet_ph_income": "Income",
  "wallet_ph_salary": "Salary (-)",
  "wallet_ph_expense": "Expense (-)",
  "wallet_ph_amount": "Amount (-)",
  "wallet_ph_desc": "Description...",
  "wallet_btn_register": "Register",
  "wallet_btn_reg_expense": "Register Expense",
  "wallet_cash": "Cash",
  "wallet_online": "Online",
  "wallet_today": "Today",
  "wallet_cash_income": "Cash Income",
  "wallet_online_income": "Online Income",
  "wallet_order_expense": "Order Expense",
  "wallet_other_expenses": "Other Expenses",
  "wallet_itog_income": "Total Income",
  "wallet_salaries": "Salaries",
  "wallet_itog_expense": "Total Expenses",
  "wallet_net_profit": "Net Profit",
  "wallet_search_ph": "Search by description...",
  "wallet_all": "All",
  "wallet_th_date": "DATE",
  "wallet_th_income": "INCOME (+)",
  "wallet_th_salary": "SALARY (-)",
  "wallet_th_order_exp": "EXPENSE (-)",
  "wallet_th_admin_exp": "OTHER (-)",
  "wallet_th_profit": "PROFIT",
  "wallet_th_desc": "PURPOSE",
  "wallet_th_tools": "TOOLS",
  "wallet_delete_confirm": "🗑 Are you sure you want to delete this transaction?",
  "wallet_prompt_income": "Income Amount (+):",
  "wallet_prompt_method": "Method (cash or online):",
  "wallet_prompt_salary": "Salary (-):",
  "wallet_prompt_order_exp": "Expense (-):",
  "wallet_prompt_admin_exp": "Other Expense (-):",
  "wallet_prompt_desc": "Purpose:",
  "workers_title": "Worker Management",
  "workers_subtitle": "Financial Control and Monitoring",
  "workers_stat_total": "Total",
  "workers_stat_balance": "Total Wallet",
  "workers_stat_low_balance": "Low Balance",
  "workers_stat_free": "Free",
  "workers_stat_blocked": "Blocked",
  "workers_stat_rating": "Rating",
  "workers_search_ph": "Search by name or specialization...",
  "workers_filter_all": "All",
  "workers_filter_free": "Free",
  "workers_filter_busy": "Busy",
  "workers_filter_blocked": "Blocked",
  "workers_th_staff": "Staff",
  "workers_th_specialization": "Specialization",
  "workers_th_balance": "Balance",
  "workers_th_status": "Status",
  "workers_th_actions": "Actions",
  "workers_default_spec": "Specialist",
  "workers_status_blocked": "Blocked",
  "workers_status_free": "Available",
  "workers_status_busy": "Busy",
  "workers_label_phone": "Phone",
  "workers_label_address": "Address",
  "workers_label_last_recharge": "Last Recharge",
  "workers_label_rating": "Overall Rating",
  "workers_not_specified": "Not specified",
  "workers_balance_error": "Balance update failed",
  "workers_confirm_verify": "Verify worker?",
  "workers_confirm_unverify": "Cancel verification?",
  "workers_confirm_block": "Block worker?",
  "workers_confirm_unblock": "Unblock worker?",
  "stats_all": "All",
  "stats_new": "New",
  "stats_processing": "Processing",
  "stats_pending": "Pending",
  "stats_confirmed": "Confirmed",
  "stats_mismatch": "Issue",
  "stats_modified": "Modified",
  "stats_in_progress": "In Progress",
  "stats_pending_finish": "Await Finish",
  "stats_finished": "Finished",
  "stats_cancelled": "Cancelled",
  "order_id": "ORDER",
  "customer_data": "CUSTOMER INFO",
  "no_name": "No name",
  "order_details": "ORDER DETAILS",
  "note": "Note",
  "no_additional_data": "No additional data",
  "total_amount": "TOTAL AMOUNT",
  "workers": "WORKERS",
  "no_workers": "No workers",
  "car": "Vehicle",
  "specialist": "Specialist",
  "driver": "Driver",
  "time_remaining": "TIME LEFT",
  "delay": "DELAY",
  "btn_accept": "ACCEPT",
  "btn_confirm": "CONFIRM",
  "btn_confirm_order": "CONFIRM ORDER",
  "btn_match": "MATCHES",
  "btn_issue": "ISSUE",
  "btn_confirm_finish": "CONFIRM FINISH",
  "btn_continue_old_price": "CONTINUE (OLD PRICE)",
  "btn_recalculate": "RECALCULATE",
  "btn_finish": "FINISH",
  "btn_change_in_progress": "CHANGE IN PROGRESS",
  "btn_reject": "REJECT / CANCEL",
  "status_new": "NEW ORDER",
  "status_processing": "PROCESSING",
  "status_pending": "PENDING",
  "status_confirmed": "CONFIRMED",
  "status_mismatch": "ISSUE / SOS",
  "status_modified": "MODIFIED",
  "status_in_progress": "IN PROGRESS",
  "status_pending_finish": "PENDING FINISH",
  "status_finished": "FINISHED",
  "status_cancelled": "CANCELLED",
  "title": "Wallet",
  "view_mode": "VIEW MODE",
  "day": "Day",
  "month": "Month",
  "year": "Year",
  "new_transaction": "NEW TRANSACTION",
  "income": "Income",
  "cash": "Cash",
  "online": "Online",
  "salary_neg": "Salary (-)",
  "expense_neg": "Expense (-)",
  "btn_register": "Register",
  "admin_expense": "ADMIN EXPENSE",
  "amount_neg": "Amount (-)",
  "purpose_placeholder": "Purpose...",
  "btn_register_expense": "Register Expense",
  "today": "Today",
  "this_month": "Month",
  "this_year": "Year",
  "cash_income": "Cash Income",
  "online_income": "Online Income",
  "order_expense_label": "Order Expense",
  "other_expenses_label": "Other Expenses",
  "total_income_label": "Total Income",
  "salaries_label": "Salaries",
  "total_expenses_label": "Total Expenses",
  "net_profit_label": "Net Profit",
  "search_placeholder": "Search by purpose...",
  "all": "All",
  "th_date": "DATE",
  "th_income": "INCOME (+)",
  "th_salary": "SALARY (-)",
  "th_expense": "EXPENSE (-)",
  "th_other": "OTHER (-)",
  "th_profit": "PROFIT",
  "th_purpose": "PURPOSE",
  "th_tools": "TOOLS",
  "confirm_delete": "🗑 Are you sure you want to delete this transaction?",
  "prompt_income": "Income Amount (+):",
  "prompt_method": "Method (cash or online):",
  "prompt_salary": "Salary (-):",
  "prompt_expense": "Expense (-):",
  "prompt_other_expense": "Other Expense (-):",
  "prompt_desc": "Purpose:",
  "wallet": {
  "title": "Wallet",
  "view_mode": "VIEW MODE",
  "day": "Day",
  "month": "Month",
  "year": "Year",
  "new_transaction": "NEW TRANSACTION",
  "income": "Income",
  "cash": "Cash",
  "online": "Online",
  "salary_neg": "Salary (-)",
  "expense_neg": "Expense (-)",
  "btn_register": "Register",
  "admin_expense": "ADMIN EXPENSE",
  "amount_neg": "Amount (-)",
  "purpose_placeholder": "Purpose...",
  "btn_register_expense": "Register Expense",
  "today": "Today",
  "this_month": "Month",
  "this_year": "Year",
  "cash_income": "Cash Income",
  "online_income": "Online Income",
  "order_expense_label": "Order Expense",
  "other_expenses_label": "Other Expenses",
  "total_income_label": "Total Income",
  "salaries_label": "Salaries",
  "total_expenses_label": "Total Expenses",
  "net_profit_label": "Net Profit",
  "search_placeholder": "Search by purpose...",
  "all": "All",
  "th_date": "DATE",
  "th_income": "INCOME (+)",
  "th_salary": "SALARY (-)",
  "th_expense": "EXPENSE (-)",
  "th_other": "OTHER (-)",
  "th_profit": "PROFIT",
  "th_purpose": "PURPOSE",
  "th_tools": "TOOLS",
  "confirm_delete": "🗑 Are you sure you want to delete this transaction?",
  "prompt_income": "Income Amount (+):",
  "prompt_method": "Method (cash or online):",
  "prompt_salary": "Salary (-):",
  "prompt_expense": "Expense (-):",
  "prompt_other_expense": "Other Expense (-):",
  "prompt_desc": "Purpose:"
},
  "status": {
    "new": "NEW ORDER",
    "processing": "PROCESSING",
    "pending_admin": "PENDING",
    "confirmed": "CONFIRMED",
    "mismatch": "PROBLEM / SOS",
    "modified": "MODIFIED",
    "in_progress": "IN PROGRESS",
    "pending_finish": "PENDING FINISH",
    "finished": "FINISHED",
    "cancelled": "CANCELLED"
  },
  "order": {
    "id_label": "ORDER #",
    "total_price": "TOTAL PRICE",
    "car": "🚛 Car",
    "worker": "👨‍🔧 Worker"
  },
  "section": {
    "customer": "CUSTOMER DETAILS",
    "details": "ORDER DETAILS",
    "workers": "WORKERS"
  },
  "btn": {
    "accept": "ACCEPT",
    "confirm": "✅ CONFIRM",
    "confirm_order": "CONFIRM ORDER",
    "match": "MATCHES",
    "problem": "PROBLEM",
    "confirm_finish": "CONFIRM FINISH",
    "continue_old": "✅ CONTINUE (OLD PRICE)",
    "recalculate": "🔄 RECALCULATE",
    "finish": "FINISH",
    "change_progress": "CHANGE IN PROGRESS",
    "reject": "REJECT / CANCEL"
  },
  "role": {
    "driver": "🚛 Driver",
    "worker": "👨‍🔧 Worker"
  },
  "timer": {
    "delay": "🚨 DELAY",
    "left": "⌛ TIME LEFT"
  },
  "time": {
    "m": "m",
    "s": "s"
  },
  "common": {
    "no_name": "No name",
    "no_data": "No additional data",
    "no_worker": "👤 No workers",
    "note": "Note",
    "reason_prompt": "Reason:"
  },
  "confirm": {
    "remove_worker": "Are you sure you want to remove the worker from this order?"
  },

 "wallet": {
  "title": "Wallet",
  "view_mode": "VIEW MODE",
  "day": "Day",
  "month": "Month",
  "year": "Year",
  "new_transaction": "NEW TRANSACTION",
  "income": "Income",
  "cash": "Cash",
  "online": "Online",
  "salary_neg": "Salary (-)",
  "expense_neg": "Expense (-)",
  "btn_register": "Register",
  "admin_expense": "ADMIN EXPENSE",
  "amount_neg": "Amount (-)",
  "purpose_placeholder": "Purpose...",
  "btn_register_expense": "Register Expense",
  "today": "Today",
  "this_month": "Month",
  "this_year": "Year",
  "cash_income": "Cash Income",
  "online_income": "Online Income",
  "order_expense_label": "Order Expense",
  "other_expenses_label": "Other Expenses",
  "total_income_label": "Total Income",
  "salaries_label": "Salaries",
  "total_expenses_label": "Total Expenses",
  "net_profit_label": "Net Profit",
  "search_placeholder": "Search by purpose...",
  "all": "All",
  "th_date": "DATE",
  "th_income": "INCOME (+)",
  "th_salary": "SALARY (-)",
  "th_expense": "EXPENSE (-)",
  "th_other": "OTHER (-)",
  "th_profit": "PROFIT",
  "th_purpose": "PURPOSE",
  "th_tools": "TOOLS",
  "confirm_delete": "🗑 Are you sure you want to delete this transaction?",
  "prompt_income": "Income Amount (+):",
  "prompt_method": "Method (cash or online):",
  "prompt_salary": "Salary (-):",
  "prompt_expense": "Expense (-):",
  "prompt_other_expense": "Other Expense (-):",
  "prompt_desc": "Purpose:"
}  ,},},
      ru: {
        translation: {
          "about_us": "О нас",
          "loading": "Загрузка...",
          "no_info_added": "Информация еще не добавлена.",
          "total_visits": "Общие визиты",
          "unique_users": "Уникальные пользователи",
          "total_orders": "Всего заказов",
          "site_analytics": "Аналитика сайта",

          // Calculators Hub
          "online_calculators": "ОНЛАЙН КАЛЬКУЛЯТОРЫ",
          "back_to_list": "НАЗАД К СПИСКУ",
          "calculate_btn": "РАССЧИТАТЬ",
          "order_now": "ЗАКАЗАТЬ",
          "calc_trash_removal": "Вывоз строительного мусора и хлама",
          "calc_moving": "Грузоперевозки",
          "calc_master": "Бытовой помощник (Мастер)",
          "calc_demolition": "Демонтажные работы и вывоз мусора",
          "calc_cleaning": "Уборочные работы",
          "calc_fura": "Разгрузка фур",
          "calc_machinery": "Предоставление техники",

          "admin_analytics": "Аналитика",
          "admin_workers": "Работники",
          "admin_users": "Пользователи",
          "admin_wallet": "Кошелек",
          "admin_orders": "Заказы",
          "admin_assets": "Предметы калькулятора",
          "admin_cars": "Машины",
          "admin_messages": "Сообщения",
          "admin_bot": "Обучение бота",
          "admin_notifications": "Уведомления",
          "admin_portfolio": "Проекты",
          "admin_services": "Услуги",
          "admin_slides": "Слайдер",
          "admin_categories": "Категории",
          "admin_partners": "Партнеры",
          "admin_reviews": "Отзывы",
          "admin_faq": "FAQ",
          "admin_about": "О нас",
          "admin_contacts": "Контакты",

          "admin_welcome": "Добро пожаловать, войдите в систему",
          "username": "Имя пользователя",
          "password": "Пароль",
          "login_btn": "ВОЙТИ",
          "logout": "ВЫХОД",

          "status_new": "НОВЫЙ ЗАКАЗ",
          "status_confirmed": "ПОДТВЕРЖДЕНО",
          "status_finished": "ЗАВЕРШЕНО",
          "status_cancelled": "ОТМЕНЕНО",
          "contact_us_title": "СВЯЗАТЬСЯ С НАМИ",
"contact_us_subtitle": "Выберите удобный вариант связи",
"call_button": "ПОЗВОНИТЬ",
"cancel_btn": "Отмена",
"bot_welcome": "Здравствуйте! Я Liber Bot. Чем могу вам помочь?",
"bot_placeholder": "Введите ваше сообщение...",
"bot_online": "В сети",
"bot_error_response": "Извините, не удалось обработать ответ.",
"bot_connection_error": "Ошибка связи. Попробуйте позже.",
"contact_back": "Назад",
"contact_main_title": "СВЯЗЬ С НАМИ",
"contact_tab_write": "Написать",
"contact_tab_inbox": "Ответы",
"contact_form_title": "Обратная Связь",
"contact_label_name": "Имя",
"contact_label_phone": "Телефон",
"contact_label_subject": "Тема",
"contact_label_message": "Сообщение",
"contact_subject_placeholder": "По какому вопросу",
"contact_attach_image": "Прикрепить фото",
"contact_file_selected": "Выбрано",
"contact_btn_send": "ОТПРАВИТЬ ПИСЬМО",
"contact_sending": "Отправка...",
"contact_success": "Отправлено",
"contact_login_required": "Пожалуйста, сначала войдите",
"contact_no_messages": "Нет сообщений",
"contact_reply_from": "Ответ от Liber Group",
"contact_view_attachment": "Посмотреть файл",
"contact_delete_confirm": "Удалить это сообщение?",
"contact_default_subject": "Запрос",
"faq_main_title": "Часто задаваемые вопросы",
"faq_q1": "Как сделать заказ?",
"faq_a1": "Выберите услугу, нажмите кнопку «Заказать» и заполните свои данные.",
"faq_q2": "Как быстро приедет специалист?",
"faq_a2": "После подтверждения заказа специалист приедет в течение 1 часа.",
"faq_q3": "Предоставляется ли гарантия?",
"faq_a3": "Да, мы предоставляем гарантию качества на все виды работ.",
"fav_loading": "Загрузка...",
"fav_back": "Назад",
"fav_title": "Мое избранное",
"fav_subtitle": "Коллекция услуг, которые вам понравились",
"fav_empty_title": "Список пуст",
"fav_empty_text": "У вас пока нет выбранных услуг.",
"fav_explore_btn": "Посмотреть услуги",
"fav_price_contract": "Договорная",
"footer_rights": "Все права защищены.",
"footer_company": "Компания",
"footer_about": "О нас",
"footer_projects": "Проекты",
"footer_terms": "Условия использования",
"footer_contact": "Свяжитесь с нами",
"nav_home": "Главная",
"nav_services": "Услуги",
"nav_projects": "Проекты",
"nav_about": "О нас",
"nav_contact": "Контакт",
"nav_login": "ВХОД",
"nav_register": "РЕГИСТРАЦИЯ",
"nav_profile": "Мой профиль",
"nav_orders": "Заказы",
"nav_favorites": "Избранное",
"nav_logout": "Выход",
"loading": "Загрузка...",
"home_hero_slogan": "ПРОФЕССИОНАЛЬНЫЕ УСЛУГИ",
"home_quick_contact": "БЫСТРАЯ СВЯЗЬ",
"home_services_title": "НАШИ УСЛУГИ",
"home_card_badge": "БЫСТРО И КАЧЕСТВЕННО",
"home_see_more": "ПОՍՄՈՏՐԵՏЬ БОЛЬШЕ",
"inv_prof_service": "Профессиональные клининговые услуги",
"inv_title": "ИНВОЙС",
"inv_number": "Номер",
"inv_date": "Дата",
"inv_from": "От кого",
"inv_company_name": "Либер Сервис ООО",
"inv_company_addr": "Ереван, Армения",
"inv_customer": "Клиент",
"inv_dear_customer": "Уважаемый клиент",
"inv_th_service": "Услуга",
"inv_th_qty": "Кол-во",
"inv_th_price": "Цена",
"inv_total": "Итого",
"inv_btn_download": "Скачать PDF",
"inv_btn_close": "Закрыть",
"login_subtitle": "Войдите в систему",
"login_username": "Имя пользователя",
"login_username_placeholder": "Имя пользователя",
"login_password": "Пароль",
"login_password_placeholder": "Пароль",
"login_btn_submit": "Войти",
"login_btn_loading": "Вход...",
"login_error_failed": "Ошибка входа",
"login_error_server": "Сервер недоступен. Проверьте соединение.",
"nav_home": "ГЛАВНАЯ",
"nav_projects": "ПРОЕКТЫ",
"nav_about": "О НАС",
"nav_favorites": "ИЗБРАННОЕ",
"nav_services": "УСЛУГИ",
"nav_contact": "СВЯЗЬ",
"nav_login": "ВХОД",
"nav_profile": "МОЙ ПРОФИЛЬ",
"nav_orders": "Заказ",
"admin_notifications": "Уведомления",
"admin_partners": "ПАРТНЕРЫ",
"online_calculators": "КАЛЬКУЛЯТОРЫ",
"home_see_more": "ПОСМОТРЕТЬ ВСЕ",
"contact_label_subject": "Заголовок",
"contact_label_message": "Сообщение",
"contact_subject_placeholder": "Заголовок (напр. Скидки)",
"contact_btn_send": "Отправить всем",
"contact_sending": "Отправка...",
"contact_success": "Уведомление успешно отправлено",
"contact_tab_inbox": "История",
"contact_no_messages": "История пуста",
"contact_delete_confirm": "Удалить эту историю?",
"status_new": "Новый",
"status_pending": "В процессе",
"status_completed": "Завершено",
"bot_connection_error": "Ошибка соединения",
"bot_error_response": "Ошибка",
"status_label": "Статус",
"status_pending": "Ожидание",
"status_in_progress": "В процессе",
"status_completed": "Завершено",
"status_cancelled": "Отменено",
"notification_center_title": "Центр уведомлений",
"login_required_notifs": "Пожалуйста, войдите, чтобы увидеть уведомления",
"notif_type_global": "ОБЩЕЕ",
"notif_type_personal": "ЛИЧНОЕ",
"order_finish_payment": "Завершение и Оплата",
"order_finish_subtitle": "Подтвердите и оплатите, чтобы закрыть заказ",
"payment_method_label": "Способ оплаты",
"payment_method_cash": "Наличные",
"payment_method_online": "Онлайн",
"payment_method_later": "Оплатить позже (Долг)",
"online_payment_instruction": "Переведите сумму и нажмите подтвердить.",
"payment_comment_warning": "Укажите этот код в комментарии:",
"rate_master_label": "Оцените мастера",
"btn_confirm_transfer": "✅ Я ПЕРЕВЕЛ (ПОДТВЕРДИТЬ)",
"btn_confirm_payment": "ПОДТВЕРДИТЬ ОПЛАТУ",
"price_change_title": "Изменение цены",
"price_change_subtitle": "Мастер предлагает новую цену",
"btn_agree": "Согласен",
"btn_reject": "Отклонить",
"floating_pay_waiting": "Заказ ожидает оплаты",
"floating_price_change": "Подтверждение изменения цены",
"btn_copy": "Коп.",
"copy_status_success": "Скопировано",
"btn_back": "Назад",
"order_confirmation_title": "Подтверждение",
"fill_required_fields": "Заполните обязательные поля *",
"form_full_name": "Имя и Фамилия",
"form_phone": "Телефон",
"form_date": "Дата",
"form_time": "Время",
"form_address": "Адрес",
"form_notes": "Заметки",
"placeholder_name": "Имя",
"placeholder_address": "Улица, дом...",
"placeholder_notes": "Дополнительная инфо...",
"btn_confirm_order": "ПОДТВЕРДИТЬ ЗАКАЗ",
"gps_not_supported": "GPS не поддерживается",
"location_fetch_error": "Не удалось получить местоположение",
"order_success_msg": "Заказ успешно оформлен ✅",
"order_failed_msg": "Не удалось оформить заказ",
"error_label": "Ошибка",
"default_service_name": "ВЫВОЗ СТРОЙМУСОРА",
  "partners_title_prefix": "Наши",
  "partners_title_main": "Партнеры",
  "loading": "Загрузка",
  "no_partners": "Партнеров пока нет",
  "portfolio_title_prefix": "Наши",
  "portfolio_title_main": "Проекты",
  "portfolio_subtitle": "Каждый проект является свидетельством нашего качества и профессионализма",
  "portfolio_photo_count": "Фотографий",
  "no_projects": "Работ пока нет.",
  "loading": "Загрузка",
  "register_page_title": "Регистрация",
  "register_subtitle": "Создайте свой аккаунт прямо сейчас",
  "form_full_name": "Имя Фамилия",
  "form_email": "Эл. почта",
  "form_phone": "Номер телефона",
  "form_password": "Пароль",
  "form_confirm_password": "Повторите пароль",
  "placeholder_name": "Арам Арамян",
  "pass_hint_chars": "8+ символов",
  "pass_hint_number": "Цифра",
  "pass_hint_upper": "Заглавная буква",
  "error_pass_mismatch": "Пароли не совпадают",
  "btn_create_account": "Создать аккаунт",
  "already_have_account": "Уже есть аккаунт?",
  "login_link": "Войти",
  "register_success_alert": "Поздравляем! Регистрация прошла успешно:",
  "error_404_server": "Ошибка. Адрес сервера не найден (404):",
  "register_error_generic": "Ошибка регистрации. Данные уже используются:",
  "error_server_unavailable": "Сервер недоступен. Проверьте соединение:",
  "review_access_denied": "Доступ ограничен",
"review_login_prompt": "Войдите в свой аккаунт, чтобы оставить отзыв",
"alert_select_stars": "Пожалуйста, выберите количество звезд",
"alert_write_review": "Пожалуйста, напишите ваш отзыв",
"alert_relogin": "Пожалуйста, войдите в систему снова",
"customer_default_name": "Клиент",
"review_success_msg": "Отзыв отправлен. Спасибо ✅",
"review_error_msg": "Не удалось отправить отзыв",
"error_server_connection": "Ошибка связи с сервером",
"review_form_title": "Оставить отзыв",
"review_form_subtitle": "Ваше мнение важно для нас",
"placeholder_review_text": "Как вы оцениваете предоставленную услугу...",
"btn_sending": "Отправка...",
"btn_send_review": "Отправить отзыв",
"review_anonymous": "Аноним",
"search_placeholder": "Поиск услуги...",
"alert_login_to_review": "Войдите, чтобы оставить отзыв:",
"alert_write_text": "Пожалуйста, напишите текст:",
"review_sent_success": "✅ Отзыв отправлен",
"error_generic": "Произошла ошибка",
"service_not_found": "Услуга не найдена",
"seo_description_suffix": "в Ереване: Быстрый расчет и качественное обслуживание.",
"btn_back": "Назад",
"reviews_count_label": "отзывов",
"order_guide_title": "Руководство по заказу",
"step_1_title": "Рассчитайте",
"step_1_desc": "Нажмите «Рассчитать цену» и перейдите к калькулятору",
"step_2_title": "Закажите",
"step_2_desc": "Подтвердите расчет и оформите заказ",
"info_guarantee": "100% Гарантия",
"info_fast_service": "Быстрое Обслуживание",
"cta_ready_to_calc": "Готовы к расчету?",
"btn_calculate_price": "Рассчитать цену",
"customer_reviews_title": "Отзывы клиентов",
"placeholder_write_review": "Оставьте свой отзыв здесь...",
"btn_send": "Отправить",
"no_reviews_yet": "Отзывов пока нет",
"reviews_count_label": "отзывов",
"description_title": "Описание",
"no_description_available": "Подробное описание для этой услуги еще не добавлено.",
"btn_order_now": "ЗАКАЗАТЬ СЕЙЧАС",
"customer_reviews_title": "Отзывы клиентов",
"placeholder_write_review": "Оставьте свой отзыв...",
"btn_send": "Отправить",
"example_reviewer_name": "Армен Геворгян",
"example_review_text": "Очень хорошая и качественная услуга, рекомендую.",
"social_share_title": "Присоединяйтесь к нам и поделитесь сайтом",
"share_nav_text": "Качественное строительство и современные решения",
"alert_link_copied": "Ссылка скопирована в буфер обмена.",
"btn_share": "Поделиться",
"no_services_found_in_category": "В категории «{{category}}» услуги не найдены",
"back_to_home": "Вернуться на главную",
"price_on_request": "Цена по запросу",
"view_details": "Посмотреть подробности",
"login_page_title": "Вход",
"login_subtitle": "Войдите, чтобы продолжить",
"label_email_or_phone": "Эл. почта или Телефон",
"placeholder_login_input": "Введите ваши данные",
"label_password": "Пароль",
"link_forgot_password": "Забыли?",
"btn_login": "Войти",
"no_account_text": "Нет аккаунта?",
"link_register": "Зарегистрироваться",
"error_phone_short": "Номер телефона должен содержать не менее 9 цифр",
"error_password_short": "Пароль должен содержать не менее 6 символов",
"error_login_failed": "Ошибка входа",
"error_server_connection": "Ошибка связи с сервером",
"terms_title": "Условия использования",
"last_updated": "Последнее обновление:",
"loading": "Загрузка...",
"btn_back": "Назад",
"terms_sec1_title": "1. Общие положения",
"terms_sec1_text": "Добро пожаловать на сайт Liber Group. Используя наш сайт, вы соглашаетесь с данными условиями.",
"terms_sec2_title": "2. Предоставление услуг",
"terms_sec2_text": "Все услуги, представленные на сайте, носят информационный характер. Каждый заказ оформляется отдельным договором.",
"terms_sec3_title": "3. Конфиденциальность",
"terms_sec3_text": "Предоставленные вами личные данные используются исключительно для связи с вами.",
  "my_profile_btn": "МОЙ ПРОФИЛЬ",
  "login_btn": "ВХОД",
  "contact_btn": "СВЯЗЬ",
  "notifications_header": "УВЕДОМЛЕНИЯ",
  "notif_order_label": "Заказ",
  "notif_info": "Информация",
  "notif_announcement": "Объявление",
  "no_new_notifications": "Новых уведомлений нет",
  "see_all_notifications": "ПОՍМОТРЕТЬ ВСЕ",
  "nav_home": "ГЛАВНАЯ",
  "nav_projects": "ПРОЕКТЫ",
  "nav_about": "О НАС",
  "nav_favorites": "ИЗБРАННОЕ",
  "nav_services": "УСЛУГИ",
  "nav_partners": "ПАРТНЕРЫ",
  "nav_calculators": "КАЛЬКУЛЯТОРЫ",
  "nav_contact": "КОНТАКТЫ",
  "back_to_profile": "Назад в профиль",
    "filter_current": "Текущие",
    "filter_completed": "Завершенные",
    "filter_cancelled": "Отмененные",
    "orders_count": "заказов",
    "loading": "Загрузка...",
    "no_orders": "В этом разделе нет заказов",
    "no_address": "Адрес не указан",
    "total_price": "Итого:",
    "currency": "֏",
    "btn_pay": "ОПЛАТИТЬ",
    "btn_invoice": "Инвойс",
    "btn_cancel": "Отменить",
    "login_required": "Пожалуйста, войдите в систему:",
    "rating_done": "Ваша оценка",
    "rating_ask": "Как вы оцените работу?",
    "cancel_confirm": "Вы уверены, что хотите отменить этот заказ?",
    "cancel_success": "✅ Заказ успешно отменен",
    "cancel_error": "🚨 Ошибка при отмене",
    "review_success": "Спасибо за вашу оценку ✅",
    "review_error": "Не удалось сохранить оценку:",
    "connection_error": "Ошибка связи: Socket недоступен:",
    "new": "Новый",
      "processing": "Обрабатывается",
      "confirmed": "Подтверждено",
      "arrived": "В процессе",
      "pending_finish": "Ожидает подтверждения",
      "finished": "Завершен",
      "cancelled": "Отменен",
      "title": "МОЙ ПРОФИЛЬ",
    "role_worker": "СПЕЦИАЛИСТ",
    "role_customer": "КЛИЕНТ",
    "tab_orders": "ЗАКАЗЫ",
    "tab_info": "ДАННЫЕ",
    "tab_settings": "НАСТРОЙКИ",
    "recent_orders": "ПОСЛЕДНИЕ ЗАКАЗЫ",
    "order_id": "Заказ",
    "loading": "Загрузка...",
    "no_orders": "Заказы не найдены",
    "see_all": "ПОՍՄՈՏՐЕТЬ ВСЕ",
    "full_name": "ИМЯ И ФАМИЛИЯ",
    "email": "ЭЛ. ПОЧТА (EMAIL)",
    "phone_1": "ТЕЛЕФОН 1",
    "phone_2": "ТЕЛЕФОН 2",
    "address": "АДРЕС",
    "save_changes": "СОХРАНИТЬ ИЗМЕНЕНИЯ",
    "notifications": "УВЕДОМЛЕНИЯ",
    "email_notify": "Email уведомления",
    "sms_notify": "SMS уведомления",
    "reg_date": "Дата регистрации",
    "logout": "ВЫХОД",
    "update_success": "Данные успешно обновлены",
    "update_error": "Ошибка при обновлении данных",
    "missing_data": "Данные пользователя отсутствуют",
    "conn_error": "Ошибка связи с сервером",
  "back_to_profile": "Назад в профиль",
  "tab_current": "Текущие",
  "tab_completed": "Завершенные",
  "tab_cancelled": "Отмененные",
  "orders_count": "заказ(ов)",
  "loading": "Загрузка",
  "no_orders_in_section": "В этом разделе нет заказов",
  "no_address": "Адрес не указан",
  "your_rating": "Ваша оценка",
  "rate_work": "Как вы оцените работу?",
  "total_price_label": "Итого",
  "btn_pay": "ОПЛАТИТЬ",
  "btn_invoice": "Инвойс",
  "btn_cancel": "Отменить",
  "alert_socket_error": "Ошибка связи. Socket недоступен:",
  "customer_default_name": "Клиент",
  "rating_for_order": "Оценка для заказа",
  "alert_rating_success": "Спасибо за вашу оценку ✅",
  "alert_rating_error": "Не удалось сохранить оценку:",
  "confirm_cancel_order": "Вы уверены, что хотите отменить этот заказ?",
  "alert_cancel_success": "✅ Заказ успешно отменен",
  "alert_cancel_error": "🚨 Ошибка при отмене",
  "back_btn": "Назад",
  "reviews_count": "отзывов",
  "price_from": "Цена от",
  "order_now_btn": "Заказать сейчас",
  "customer_reviews_title": "Отзывы клиентов",
  "no_reviews_yet": "Для этой услуги пока нет отзывов. Будьте первым!",
  "service_not_found": "Услуга не найдена",
  "return_home": "Вернуться на главную",
  "alert_cancel_success": "✅ Заказ успешно отменен",
  "alert_cancel_error": "🚨 Ошибка при отмене",
  "back_btn": "Назад",
  "reviews_count": "отзывов",
  "price_from": "Цена от",
  "order_now_btn": "Заказать сейчас",
  "customer_reviews_title": "Отзывы клиентов",
  "no_reviews_yet": "Для этой услуги пока нет отзывов. Будьте первым!",
  "service_not_found": "Услуга не найдена",
  "return_home": "Вернуться на главную",
  "back_to_profile": "Назад в профиль",
  "tab_current": "Текущие",
  "tab_completed": "Завершенные",
  "tab_cancelled": "Отмененные",
  "orders_count": "заказов",
  "loading": "Загрузка",
  "no_orders_in_section": "В этом разделе нет заказов",
  "no_address": "Адрес не указан",
  "rate_work": "Оцените работу",
  "your_rating": "Ваша оценка",
  "total_price_label": "Общая сумма",
  "btn_pay": "Подтвердить и оплатить",
  "btn_invoice": "Инвойс",
  "btn_cancel": "Отменить",
  "please_login": "Пожалуйста, войдите в систему",
  "status_new": "Новый",
  "status_processing": "В процессе",
  "status_confirmed": "Подтверждено",
  "status_arrived": "Прибыл",
  "status_pending_pay": "Ожидает оплаты",
  "status_finished": "Завершено",
  "status_cancelled": "Отменено",
  "alert_socket_error": "Ошибка соединения. Попробуйте снова.",
  "alert_rating_success": "Спасибо за вашу оценку!",
  "alert_rating_error": "Ошибка при оценке.",
  "confirm_cancel_order": "Вы уверены, что хотите отменить заказ?",
  "customer_default_name": "Клиент",
  "rating_for_order": "Оценка для заказа",
  "view_all_orders": "ПОСМОТРЕТЬ ВСЕ",
  "address_label": "Адрес",
  "address_placeholder": "Введите адрес...",
  "floor_label": "Этаж",
  "elevator_label": "Лифт",
  "elevator_none": "Нет",
  "elevator_small": "Пассажирский",
  "elevator_large": "Грузовой",
  "calculate_btn": "РАССЧИТАТЬ",
  "new_calc_btn": "НОВЫЙ РАСЧЕТ",
  "select_item_alert": "Пожалуйста, выберите хотя бы один товар",
  "address": "📍 Адрес",
  "floor": "🏢 Этаж",
  "elevator": "🛗 Лифт",
  "items_list": "📦 Список грузов",
  "selected_items": "Выбранные товары",
  "summary": "🚛 Итог",
  "not_specified": "Не указано",
  "error": "Ошибка расчета",
  "single_address": "Один адрес",
"need_packing": "Упаковка",
"need_truck": "Грузовик",
"search_placeholder": "Поиск вещи...",
"total_price": "Общая цена",
"master_title": "🛠 УСЛУГИ МАСТЕРА",
"by_meter": "по метрам",
"by_count": "по количеству",
"calculation_result": "Результат расчета",
"total": "Итого:",
"back_btn": "НАЗАД",
"meter_unit": "м",
"demolition_title": "ДЕМОНТАЖНЫЕ РАБОТЫ",
"address_placeholder_house": "Улица, дом...",
"elevator_none_short": "Нет",
"elevator_small_short": "Пасс.",
"elevator_large_short": "Груз.",
"admin": {
    "calculator_management": "Управление калькуляторами",
    "new_calculator": "Новый калькулятор",
    "navbars": "Разделы меню (Navbars)",
    "add_navbar": "Добавить раздел",
    "groups": "Группы",
    "add_group": "Добавить группу",
    "group_name": "Название группы",
    "asset_list": "Список предметов (Assets)",
    "add_new_asset": "Добавить новый предмет",
    "calculator_settings": "Настройки калькулятора",
    "name": "Название",
    "icon": "Иконка",
    "factor": "Коэффициент",
    "weight": "Вес",
    "volume": "Объем",
    "volume_m3": "Объем (м³)",
    "unit": "Ед. изм.",
    "unit_m2": "кв.м",
    "unit_gmetr": "пог.м",
    "unit_hat": "шт",
    "unit_m3": "м³",
    "price": "Цена",
    "actions": "Действия",
    "elevator": "Лифт",
    "fits_elevator": "Помещается",
    "no_elevator": "Не помещается",
    "h": "ч",
    "min_hours": "Мин. часы",
    "extra_price_hr": "Доп. $/час",
    "key": "Ключ (Key)",
    "ton": "Тонна",
    "tech": "Техника",
    "wood": "Дерево",
    "pallet": "Паллет",
    "big_box": "Большой ящик",
    "front_id": "Frontend ID",
    "density": "Плотность",
    "group": "Группа",
    "min_order_price": "Мин. цена заказа",
    "base_weight": "Базовый вес",
    "base_volume": "Базовый объем",
    "price_per_km": "Цена за 1 км",
    "free_distance": "Бесплатное расстояние",
    "elevator_fee": "Плата за лифт",
    "stairs_fee": "Плата за лестницу",
    "discounts_json": "Конфиг скидок (JSON)",
    "name_required": "Название обязательно",
    "add_failed": "Ошибка при добавлении",
    "missing_edit_data": "Данные для редактирования отсутствуют",
    "endpoint_not_found": "Адрес не найден",
    "select_calculator_first": "Сначала выберите калькулятор",
    "limit_reached": "Лимит достигнут"
  },
  "common": {
    "add": "Добавить",
    "save_changes": "Сохранить изменения",
    "saving": "Сохранение...",
    "updated_successfully": "Данные обновлены",
    "update_error": "Ошибка обновления",
    "saved_successfully": "Успешно сохранено",
    "save_error": "Ошибка сохранения",
    "are_you_sure": "Вы уверены?",
    "delete_error": "Ошибка удаления"
  },
"search_work": "Поиск работы...",
"cm": "СМ",
"modify": "ИЗՄЕНИТЬ",
"select_work_alert": "Пожалуйста, выберите хотя бы одну работу",
"select_cargo_type": "Выберите тип груза",
"no_data_found": "Данные в базе не найдены",
"fill_hours_alert": "Пожалуйста, введите количество часов",
"fill_qty_alert": "Пожалуйста, введите количество",
"qty_label": "Количество",
"hours_label": "Количество часов",
"weight_label": "Общий вес (Тонн)",
"distance_label": "Расстояние (Метры)",
"dist_placeholder": "0-10м бесплатно",
"back_to_menu": "Вернуться в меню",
"calculation_ready": "Расчет готов",
"total_sum": "ОБЩАЯ СУММА",
"cargo_type": "Тип груза",
"distance": "Расстояние",
"time": "Время",
"unit_m3": "м³",
"unit_pcs": "шт",
"unit_ton": "т",
"unit_hour": "ч",
"unit_meter": "м",
"machinery_title": "Спецтехника",
"machinery_subtitle": "Выберите тип и количество часов",
"min_hours": "минимум: {{count}} ч.",
"selected_hours": "{{count}} ч.",
"hour_quantity": "Кол-во часов",
"calculation_ready": "Расчет готов",
"order_summary": "ИТОГИ ЗАКАЗА",
"total": "Итого",
"machinery_label": "Техника",
"calculate_btn": "РАССЧИТАТЬ",
"modify_btn": "ИЗՄԵՆԻՏЬ",
"calculation_error": "Ошибка расчета",
"cleaning_calc": {
  "step_1_title": "Выберите услугу",
  "general": "Общая",
  "partial": "Частичная",
  "hourly": "Почасовая",
  "dry_cleaning": "Хիմчистка",
  "standard": "Стандарт",
  "general_type": "Генеральная",
  "renovation": "После ремонта",
  "sqm": "кв.м",
  "people": "чел.",
  "hours": "час.",
  "continue": "Продолжить ➡️",
  "step_2_title": "Дополнительные детали",
  "windows": "Окна",
  "shelves": "Внутри шкафов",
  "kitchen_tech": "Кухонная техника",
  "fridge": "Холодильник",
  "oven": "Духовка",
  "hood": "Вытяжка",
  "dishwasher": "Посуда",
  "back": "Назад",
  "next": "Далее",
  "step_3_title": "Инвентарь",
  "vacuum": "Пылесос",
  "steam": "Парогенератор",
  "materials": "Материалы",
  "calculate": "РАССЧИТАТЬ",
  "result_title": "Расчет заказа",
  "total_price": "ИТОГОВАЯ ЦЕНА",
  "worker_count": "Количество сотрудников",
  "edit_data": "ИЗМЕНИТЬ ДАННЫЕ",
  "error": "Ошибка расчета"
},
"total_visits": "Всего визитов",
    "unique_users": "Уникальные пользователи",
    "total_orders": "Всего заказов",
    "site_analytics": "Аналитика сайта",
    "top_categories": "Топ категории",
    "top_subservices": "Топ подуслуги",
    "search_frequency": "Частота поиска",
    "filter_placeholder": "Фильтровать поиск...",
    "category": "Категория",
    "service": "Услуга",
    "views": "Просмотры",
    "times": "раз",
    "no_data": "Нет данных",
    "delete_confirm": "Удалить эту историю поиска?",
    "loading": "Загрузка...",
  "delete_car_confirm": "🗑 Вы уверены, что хотите удалить эту машину?",
  "total": "Всего",
  "gazels": "Газели",
  "zils": "Зилы",
  "search_placeholder": "Поиск (Имя, номер...)",
  "add_car": "Добавить машину",
  "image": "Фото",
  "name_type": "Название / Тип",
  "parameters": "Параметры",
  "plate_number": "Госномер",
  "driver": "Водитель",
  "action": "Действие",
  "no_image": "Нет фото",
  "unit_ton": "т",
  "unit_m3": "м³",
  "unit_m": "м",
  "edit_title": "Редактировать",
  "label_display_name": "Отображаемое имя",
  "label_weight": "Вес",
  "label_volume": "Объем",
  "label_length": "Длина",
  "label_plate": "Госномер",
  "save": "Сохранить",
  "cancel": "Отмена",
  "access_denied_relogin": "Доступ запрещен. Пожалуйста, войдите снова.",
  "enter_answer_error": "Пожалуйста, введите ответ",
  "error": "Ошибка",
  "train_failed": "Не удалось обучить бота",
  "delete_knowledge_confirm": "Вы уверены, что хотите удалить это знание?",
  "unanswered_count": "Без ответа",
  "knowledge_count": "База знаний",
  "bot_status": "Статус",
  "status_active": "Активен",
  "tab_training": "Обучение",
  "tab_database": "База данных",
  "refresh": "Обновить",
  "all_questions_answered": "Все вопросы отвечены ✨",
  "write_answer_placeholder": "Напишите ответ...",
  "btn_train": "Обучить",
  "table_question": "Вопрос",
  "table_answer": "Ответ",
  "table_action": "Действие",
  "database_empty": "База данных пуста",
  
  "session_expired_error": "Срок действия сессии истек или у вас нет прав доступа.",
  "delete_faq_confirm": "Удалить этот вопрос? 🗑️",
  "faq_count_label": "Кол-во вопросов",
  "faq_status_label": "Статус",
  "faq_status_published": "Опубликовано",
  "edit_faq_title": "Редактировать FAQ",
  "add_faq_title": "Добавить новый FAQ",
  "faq_question_label": "Вопрос",
  "faq_question_placeholder": "Например: Как зарегистрироваться...",
  "faq_answer_label": "Ответ",
  "faq_answer_placeholder": "Подробно опишите ответ...",
  "btn_update": "Обновить",
  "btn_save": "Сохранить",
  "existing_faqs_title": "Существующие вопросы",
  "table_question": "Вопрос",
  "table_answer": "Ответ",
  "table_action": "Действие",
  "btn_reply": "Ответить",
  "reply_modal_title": "Ответить на сообщение",
  "reply_placeholder": "Напишите ваш ответ...",
  "btn_send_reply": "Отправить ответ",
  "sending_loader": "Отправка...",
  "reply_sent_success": "✅ Ответ успешно отправлен",
  "error_missing_id": "Ошибка: ID сообщения отсутствует",
  "error_empty_reply": "Пожалуйста, напишите ответ",
  "server_error": "Ошибка сервера",
  "connection_error": "Ошибка связи с сервером",
"stats_total_messages": "Всего сообщений",
  "stats_today_messages": "Получено сегодня",
  "stats_with_files": "С вложениями",
  "status_active": "Активно",
  "inbox_title": "Входящие сообщения",
  "badge_replied": "Отвечено",
  "view_file": "Посмотреть файл",
  "customer_card": "Карточка клиента",
  "label_phone": "Телефон",
  "label_user_id": "ID пользователя",
  "label_date": "Дата",
  "not_specified": "Не указано",
  "guest_user": "Гость",
  "delete_message_confirm": "🗑 Удалить это сообщение?",
  "delete_failed": "Ошибка при удалении",
"notification_center_title": "Центр уведомлений",
  "new_message_title": "Новое сообщение",
  "label_send_to": "Кому отправить",
  "option_all_users": "Всем пользователям",
  "label_title": "Заголовок",
  "placeholder_title": "Например: Спецпредложение...",
  "label_message": "Сообщение",
  "placeholder_message": "Напишите содержание здесь...",
  "btn_send_notification": "Отправить уведомление",
  "recent_activities_title": "Последние действия",
  "history_empty": "История пуста",
  "label_users": "Пользователи",
  "label_total_sent": "Всего отправлено",
  "label_today": "Сегодня",
  "notification_sent_success": "✅ Уведомление успешно отправлено",
  "error_fill_fields": "Пожалуйста, заполните все поля",
  "error_sending": "Ошибка при отправке",
  "admin_orders_title": "Управление заказами",
  "calculator_not_available": "Калькулятор недоступен",
  "btn_close": "Закрыть",
  "confirm_remove_worker": "Вы уверены, что хотите удалить работника?",
  "price_change_prefix": "Изменение цены",
  "recalculation_sent_success": "Перерасчет успешно отправлен",
  "error_token_missing": "Токен авторизации отсутствует! Пожалуйста, войдите снова:",
  "order_closed_success": "Заказ успешно закрыт и рассчитан ✅",
  "backend_error_prefix": "Ошибка сервера",
  "unknown_error": "Неизвестная ошибка",
  "network_error": "Сетевая ошибка: Проверьте соединение с сервером:",
  "filter_all": "Все",
  "filter_new": "Новые",
  "filter_processing": "В обработке",
  "filter_pending": "Ожидание",
  "filter_confirmed": "Подтвержденные",
  "filter_problem": "Проблема",
  "filter_modified": "Измененные",
  "filter_in_progress": "В процессе",
  "filter_waiting_finish": "Ожидают завершения",
  "filter_finished": "Завершенные",
  "filter_cancelled": "Отмененные",
  "btn_see_next_10": "Показать следующие 10",
  "remaining_suffix": "осталось",
"total_projects": "Всего проектов",
  "status_label": "Статус",
  "status_active": "Активен",
  "add_project_title": "Добавить новый проект",
  "edit_project_title": "Редактировать проект",
  "project_name_label": "Название проекта",
  "project_name_placeholder": "Например: Дизайн современного дома",
  "images_label": "Изображения",
  "upload_images_hint": "Нажмите, чтобы загрузить изображения",
  "files_selected_suffix": "изобр. выбрано",
  "description_label": "Описание",
  "description_placeholder": "Опишите детали проекта...",
  "btn_save": "Сохранить",
  "btn_update": "Обновить",
  "btn_publish": "Опубликовать",
  "btn_processing": "Обработка...",
  "btn_cancel": "Отмена",
  "nav_blog": "Блог",
  "projects_list_title": "Список проектов",
  "table_col_image": "Фото",
  "table_col_name": "Название",
  "table_col_description": "Описание",
  "table_col_actions": "Действия",
  "confirm_delete_project": "Удалить этот проект? 🗑️",
  "error_session_expired": "Ваша сессия истекла. Пожалуйста, войдите снова.",
  "error_access_denied": "Действие отклонено. Войдите в систему.",
  "reviews_analytics_title": "Отзывы",
  "rating_analytics_title": "Рейтинг",
  "today_analytics_title": "Сегодня",
  "admin_reviews_main_title": "Управление отзывами",
  "no_reviews_yet": "Отзывов пока нет",
  "anonymous_user": "Аноним",
  "view_user_data_tooltip": "Посмотреть данные пользователя",
  "confirm_delete_review": "Удалить этот отзыв? 🗑️",
  "guest_badge": "Гость",
  "verified_reviewer_badge": "Верифицирован",
  "label_phone": "Телефон",
  "label_user_id": "ID пользователя",
  "label_registration_date": "Дата регистрации",
  "not_specified": "Не указано",
  "n_a": "Н/Д",
  "ana_services": "Услуги",
  "ana_categories": "Категории",
  "add_service": "Добавить новую услугу",
  "edit_service": "Редактировать услугу",
  "label_category": "Категория",
  "label_service_name": "Название услуги",
  "label_price": "Цена (AMD)",
  "label_image": "Изображение",
  "label_description": "Описание",
  "placeholder_service_name": "Напр: Лазерная резка",
  "placeholder_price": "Напр: 5000",
  "placeholder_description": "Детальное описание услуги...",
  "select_option": "Выбрать...",
  "upload_image": "Загрузить фото",
  "btn_save": "Сохранить",
  "btn_update": "Обновить",
  "btn_processing": "Обработка...",
  "active_services_title": "Действующие услуги",
  "table_image": "Фото",
  "table_service": "Услуга",
  "table_category": "Категория",
  "table_price": "Цена",
  "table_actions": "Действия",
  "price_negotiable": "Дог.",
  "no_data": "Данных нет",
  "confirm_delete_service": "Удалить эту услугу? 🗑️",
  "error_session_expired": "Ваша сессия истекла. Пожалуйста, войдите снова.",
  "tab_slides": "Слайды",
  "tab_categories": "Категории",
  "tab_partners": "Партнеры",
  "tab_posts": "Записи",
  "total_label": "Всего",
  "unit_count": "ед.",
  "status_label": "Статус",
  "status_active": "Активен",
  "edit_label": "Редактировать",
  "add_new_label": "Добавить новый",
  "placeholder_title": "Заголовок",
  "placeholder_description": "Описание",
  "placeholder_name": "Название",
  "placeholder_icon_class": "Класс иконки (напр. fa-star)",
  "placeholder_partner_name": "Имя партнера",
  "selected_label": "Выбрано",
  "click_to_upload": "Нажмите, чтобы выбрать фото",
  "btn_save": "Сохранить",
  "btn_update": "Обновить",
  "btn_processing": "Обработка...",
  "table_image": "Фото",
  "table_info": "Информация",
  "table_actions": "Действия",
  "confirm_delete": "Подтвердить удаление? 🗑️",
  "tab_about": "О нас",
  "tab_contacts": "Контактные данные",
  "manage_info_subtitle": "Управляйте основной информацией сайта",
  "loading": "Загрузка...",
  "label_content_hy": "Содержание (Armenian)",
  "label_content_ru": "Содержание (Russian)",
  "placeholder_about": "Опишите вашу компанию...",
  "label_phone": "Телефон",
  "label_email": "Эл. почта",
  "label_address": "Адрес",
  "seo_title": "Liber Group | Цифровая экосистема логистики нового поколения",
  "seo_description": "Liber Group: Автоматизированная логистическая платформа в Ереване. Услуги 7-в-1 с онлайн-калькулятором и фиксированными ценами.",
  "seo_keywords": "грузоперевозки, вывоз мусора, онлайн калькулятор, liber group",
  "hero_badge": "ЦИФРОВАЯ ЭКОСИСТЕМА НОВОГО ПОКОЛЕНИЯ",
  "auto_algorithm": "АВТОМАТИЗИРОВАННЫЙ АЛГОРИТМ",
  "working_hours": "Система работает в режиме 24/7",
  "hero_highlights": ["ВЫВОЗ СТРОЙМУСОРА", "РАЗГРУЗКА", "ПРОФЕССИОНАЛЬНАЯ УБОРКА", "УСЛУГИ МАСТЕРА", "ГРУЗОПЕРЕВОЗКИ", "СМАРТ ЛОГИСТИКА"],
  "ecosystem_tag": "ЭКОСИСТЕМА",
  "booking_title_1": "БРОНИРОВАНИЕ",
  "booking_title_2": "ЗА 60 СЕКУНД",
  "step_1_label": "ЭТАП 01",
  "step_1_desc": "Введите данные и получите мгновенный расчет",
  "step_2_label": "ЭТАП 02",
  "step_2_desc": "Онлайн управление заказом",
  "automated_note": "Полностью автоматизированный процесс",
  "home_services_title": "Наши Услуги",
  "professional_service": "Профессиональный сервис",
  "home_see_more": "Подробнее",
  "label_socials": "Социальные сети",
  "btn_saving": "Сохранение...",
  "btn_save_all": "Сохранить все изменения",
  "alert_success": "Изменения успешно сохранены ✨",
  "alert_session_expired": "Ваша сессия истекла. Пожалуйста, войдите снова.",
  "alert_error_save": "Произошла ошибка при сохранении.",
  "alert_conn_error": "Ошибка связи с сервером.",
  "users_center_title": "Центр Пользователей",
  "users_center_subtitle": "Полный контроль всех пользователей системы",
  "stat_total": "Всего",
  "stat_total_balance": "Общий Баланс",
  "stat_active": "Активные",
  "stat_blocked": "Заблокированные",
  "search_placeholder": "Поиск по имени, ID или телефону...",
  "btn_refresh_list": "Обновить список",
  "loading": "Загрузка...",
  "col_user": "Пользователь",
  "col_contacts": "Контакты",
  "col_balance": "Баланс",
  "col_date": "Дата",
  "col_status": "Статус",
  "col_actions": "Действие",
  "status_blocked": "Заблокирован",
  "status_verified": "Верифицирован",
  "no_users_found": "Пользователи не найдены",
  "confirm_block_user": "⚠️ Заблокировать пользователя?",
  "confirm_unblock_user": "✅ Разблокировать пользователя?",
  "prompt_new_balance": "Введите новый баланс:",
  "tooltip_bypay": "Статус By-Pay",
  "tooltip_block": "Заблокировать",
  "tooltip_unblock": "Разблокировать",
  "tooltip_view_profile": "Просмотреть профиль",
  "alert_error_auth_status": "Произошла ошибка (404 или ошибка Auth)",
  "alert_server_error": "Ошибка: Убедитесь, что сервер запущен",
  "day": "День",
  "month": "Месяц",
  "year": "Год",
  "wallet_view_mode": "РЕЖИМ ПРОСМОТРА",
  "wallet_new_transaction": "НОВАЯ ОПЕРАЦИЯ",
  "wallet_admin_expense": "АДМИН. РАСХОД",
  "wallet_ph_income": "Доход",
  "wallet_ph_salary": "Зарплата (-)",
  "wallet_ph_expense": "Расход (-)",
  "wallet_ph_amount": "Сумма (-)",
  "wallet_ph_desc": "Цель...",
  "wallet_btn_register": "Регистрация",
  "wallet_btn_reg_expense": "Регистрация расхода",
  "wallet_cash": "Наличные",
  "wallet_online": "Онлайн",
  "wallet_today": "Сегодня",
  "wallet_cash_income": "Наличный доход",
  "wallet_online_income": "Онлайн доход",
  "wallet_order_expense": "Расходы по заказу",
  "wallet_other_expenses": "Прочие расходы",
  "wallet_itog_income": "Итого доходов",
  "wallet_salaries": "Зарплаты",
  "wallet_itog_expense": "Итого расходов",
  "wallet_net_profit": "Чистая прибыль",
  "wallet_search_ph": "Поиск по цели...",
  "wallet_all": "Все",
  "wallet_th_date": "ДАТА",
  "wallet_th_income": "ДОХОД (+)",
  "wallet_th_salary": "З/П (-)",
  "wallet_th_order_exp": "РАСХОД (-)",
  "wallet_th_admin_exp": "ПРОЧЕЕ (-)",
  "wallet_th_profit": "ПРИБЫЛЬ",
  "wallet_th_desc": "ЦЕЛЬ",
  "wallet_th_tools": "ИНСТРУМЕНТЫ",
  "wallet_delete_confirm": "🗑 Вы уверены, что хотите удалить эту операцию?",
  "wallet_prompt_income": "Сумма дохода (+):",
  "wallet_prompt_method": "Метод (cash или online):",
  "wallet_prompt_salary": "Зарплата (-):",
  "wallet_prompt_order_exp": "Расход (-):",
  "wallet_prompt_admin_exp": "Прочий расход (-):",
  "wallet_prompt_desc": "Цель/Описание:",
  "workers_title": "Управление персоналом",
  "workers_subtitle": "Финансовый контроль и мониторинг",
  "workers_stat_total": "Всего",
  "workers_stat_balance": "Общий баланс",
  "workers_stat_low_balance": "Низкий баланс",
  "workers_stat_free": "Свободны",
  "workers_stat_blocked": "Заблокированы",
  "workers_stat_rating": "Рейтинг",
  "workers_search_ph": "Поиск по имени или специальности...",
  "workers_filter_all": "Все",
  "workers_filter_free": "Свободны",
  "workers_filter_busy": "Заняты",
  "workers_filter_blocked": "Заблокированы",
  "workers_th_staff": "Персонал",
  "workers_th_specialization": "Специальность",
  "workers_th_balance": "Баланс",
  "workers_th_status": "Статус",
  "workers_th_actions": "Действие",
  "workers_default_spec": "Специалист",
  "workers_status_blocked": "Заблокирован",
  "workers_status_free": "Свободен",
  "workers_status_busy": "Занят",
  "workers_label_phone": "Телефон",
  "workers_label_address": "Адрес",
  "workers_label_last_recharge": "Последнее пополнение",
  "workers_label_rating": "Общий рейтинг",
  "workers_not_specified": "Не указано",
  "workers_balance_error": "Ошибка при обновлении баланса",
  "workers_confirm_verify": "Подтвердить мастера?",
  "workers_confirm_unverify": "Отменить подтверждение?",
  "workers_confirm_block": "Заблокировать?",
  "workers_confirm_unblock": "Разблокировать?",
  "stats_all": "Все",
  "stats_new": "Новые",
  "stats_processing": "Обработка",
  "stats_pending": "Ожидание",
  "stats_confirmed": "Подтвержден",
  "stats_mismatch": "Проблема",
  "stats_modified": "Изменен",
  "stats_in_progress": "В процессе",
  "stats_pending_finish": "Ожидает завершения",
  "stats_finished": "Завершено",
  "stats_cancelled": "Отменено",
  "order_id": "ЗАКАЗ",
  "customer_data": "ДАННЫЕ КЛИЕНТА",
  "no_name": "Имя не указано",
  "order_details": "ДЕТАЛИ ЗАКАЗА",
  "note": "Примечание",
  "no_additional_data": "Дополнительные данные отсутствуют",
  "total_amount": "ОБЩАЯ СУММА",
  "workers": "РАБОТНИКИ",
  "no_workers": "Нет работников",
  "car": "Машина",
  "specialist": "Мастер",
  "driver": "Водитель",
  "time_remaining": "ОСТАЛОСЬ",
  "delay": "ЗАДЕРЖКА",
  "btn_accept": "ПРИНЯТЬ",
  "wallet": {
  "title": "Кошелек",
  "view_mode": "РЕЖИМ ПРОСМОТРА",
  "day": "День",
  "month": "Месяц",
  "year": "Год",
  "new_transaction": "НОВАЯ ОПЕРАЦИЯ",
  "income": "Доход",
  "cash": "Наличные",
  "online": "Онлайн",
  "salary_neg": "Зарплата (-)",
  "expense_neg": "Расход (-)",
  "btn_register": "Регистрация",
  "admin_expense": "АДМИН РАСХОД",
  "amount_neg": "Сумма (-)",
  "purpose_placeholder": "Цель...",
  "btn_register_expense": "Записать расход",
  "today": "Сегодня",
  "this_month": "Месяц",
  "this_year": "Год",
  "cash_income": "Наличный доход",
  "online_income": "Онлайн доход",
  "order_expense_label": "Расход заказа",
  "other_expenses_label": "Прочие расходы",
  "total_income_label": "Итого доходов",
  "salaries_label": "Зарплаты",
  "total_expenses_label": "Итого расходов",
  "net_profit_label": "Чистая прибыль",
  "search_placeholder": "Поиск по цели...",
  "all": "Все",
  "th_date": "ДАТА",
  "th_income": "ДОХОД (+)",
  "th_salary": "ЗП (-)",
  "th_expense": "РАСХОД (-)",
  "th_other": "ПРОЧЕЕ (-)",
  "th_profit": "ПРИБЫЛЬ",
  "th_purpose": "ЦЕЛЬ",
  "th_tools": "ИНСТРУМЕНТЫ",
  "confirm_delete": "🗑 Вы уверены, что хотите удалить эту операцию?",
  "prompt_income": "Сумма дохода (+):",
  "prompt_method": "Тип (cash или online):",
  "prompt_salary": "Зарплата (-):",
  "prompt_expense": "Расход (-):",
  "prompt_other_expense": "Прочий расход (-):",
  "prompt_desc": "Цель:"
},
  "btn_confirm": "ПОДТВЕРДИТЬ",
  "btn_confirm_order": "ПОДТВЕРДИТЬ ЗАКАЗ",
  "btn_match": "СООТВЕТСТВУЕТ",
  "btn_issue": "ПРОБЛЕМА",
  "btn_confirm_finish": "ПОДТВЕРДИТЬ ЗАВЕРШЕНИЕ",
  "btn_continue_old_price": "ПРОДОЛЖИТЬ (СТАРАЯ ЦЕНА)",
  "btn_recalculate": "ПЕРЕСЧИТАТЬ (КАЛЬКУЛЯТОР)",
  "btn_finish": "ЗАВЕРШИТЬ",
  "btn_change_in_progress": "ИЗМЕНИТЬ В ПРОЦЕССЕ",
  "btn_reject": "ОТКЛОНИТЬ / ОТМЕНИТЬ",
  "confirm_worker_remove": "Вы подтверждаете удаление мастера из заказа?",
  "status_new": "НОВЫЙ ЗАКАЗ",
  "status_processing": "В ОБРАБОТКЕ",
  "status_pending": "В ОЖИДАНИИ",
  "status_confirmed": "ПОДТВЕРЖДЕН",
  "status_mismatch": "ПРОБЛЕМА / SOS",
  "status_modified": "ИЗМЕНЕН",
  "status_in_progress": "В ПРОЦЕССЕ",
  "status_pending_finish": "ПОДТВЕРЖДЕНИЕ ЗАВЕРШЕНИЯ",
  "status_finished": "ЗАВЕРШЕНО",
  "status_cancelled": "ОТМЕНЕНО",
  "prompt_cancel_reason": "Причина отмены:",
  "status": {
    "new": "НОВЫЙ ЗАКАЗ",
    "processing": "В ОБРАБОТКЕ",
    "pending_admin": "ОЖИДАНИЕ",
    "confirmed": "ПОДТВЕРЖДЕНО",
    "mismatch": "ПРОБЛЕМА / SOS",
    "modified": "ИЗМЕНЕНО",
    "in_progress": "В ПРОЦЕССЕ",
    "pending_finish": "ПОДТВЕРЖДЕНИЕ ЗАВЕРШЕНИЯ",
    "finished": "ЗАВЕРШЕНО",
    "cancelled": "ОТМЕНЕНО"
  },
  "order": {
    "id_label": "ЗАКАЗ #",
    "total_price": "ОБЩАЯ СУММА",
    "car": "🚛 Машина",
    "worker": "👨‍🔧 Мастер"
  },
  "section": {
    "customer": "ДАННЫЕ КЛИЕНТА",
    "details": "ДЕТАЛИ ЗАКАЗА",
    "workers": "РАБОТНИКИ"
  },
  "btn": {
    "accept": "ПРИНЯТЬ",
    "confirm": "✅ ПОДТВЕРДИТЬ",
    "confirm_order": "ПОДТВЕРДИТЬ ЗАКАЗ",
    "match": "СООТВЕТСТВУЕТ",
    "problem": "ПРОБЛЕМА",
    "confirm_finish": "ПОДТВЕРДИТЬ ЗАВЕРШЕНИЕ",
    "continue_old": "✅ ПРОДОЛЖИТЬ (СТАРАЯ ЦЕНА)",
    "recalculate": "🔄 ПЕРЕСЧИТАТЬ",
    "finish": "ЗАВЕРШИТЬ",
    "change_progress": "ИЗМЕНИТЬ В ПРОЦЕССЕ",
    "reject": "ОТКЛОНИТЬ / ОТМЕНИТЬ"
  },
  "role": {
    "driver": "🚛 Водитель",
    "worker": "👨‍🔧 Мастер"
  },
  "timer": {
    "delay": "🚨 ЗАДЕРЖКА",
    "left": "⌛ ОСТАЛОСЬ"
  },
  "time": {
    "m": "м",
    "s": "с"
  },
  "common": {
    "no_name": "Нет имени",
    "no_data": "Нет дополнительных данных",
    "no_worker": "👤 Нет работников",
    "note": "Примечание",
    "reason_prompt": "Причина:"
  },
  "confirm": {
    "remove_worker": "Вы подтверждаете удаление мастера из заказа?"
  }
        },
        "wallet": {
  "title": "Кошелек",
  "view_mode": "РЕЖИМ ПРОСМОТРА",
  "day": "День",
  "month": "Месяц",
  "year": "Год",
  "new_transaction": "НОВАЯ ОПЕРАЦИЯ",
  "income": "Доход",
  "cash": "Наличные",
  "online": "Онлайн",
  "salary_neg": "Зарплата (-)",
  "expense_neg": "Расход (-)",
  "btn_register": "Регистрация",
  "admin_expense": "АДМИН РАСХОД",
  "amount_neg": "Сумма (-)",
  "purpose_placeholder": "Цель...",
  "btn_register_expense": "Записать расход",
  "today": "Сегодня",
  "this_month": "Месяц",
  "this_year": "Год",
  "cash_income": "Наличный доход",
  "online_income": "Онлайн доход",
  "order_expense_label": "Расход заказа",
  "other_expenses_label": "Прочие расходы",
  "total_income_label": "Итого доходов",
  "salaries_label": "Зарплаты",
  "total_expenses_label": "Итого расходов",
  "net_profit_label": "Чистая прибыль",
  "search_placeholder": "Поиск по цели...",
  "all": "Все",
  "th_date": "ДАТА",
  "th_income": "ДОХОД (+)",
  "th_salary": "ЗП (-)",
  "th_expense": "РАСХОД (-)",
  "th_other": "ПРОЧЕЕ (-)",
  "th_profit": "ПРИБЫЛЬ",
  "th_purpose": "ЦЕЛЬ",
  "th_tools": "ИНСТРУМЕНТЫ",
  "confirm_delete": "🗑 Вы уверены, что хотите удалить эту операцию?",
  "prompt_income": "Сумма дохода (+):",
  "prompt_method": "Тип (cash или online):",
  "prompt_salary": "Зарплата (-):",
  "prompt_expense": "Расход (-):",
  "prompt_other_expense": "Прочий расход (-):",
  "prompt_desc": "Цель:"
}
      }
    },
  fallbackLng: 'hy', // Եթե լեզուն չգտնի, թող բացի հայերեն
    detection: {
      // Սահմանում ենք հերթականությունը, թե որտեղից կարդա լեզուն
      order: ['localStorage', 'cookie', 'htmlTag', 'navigator'], 
      // Պարտադիր նշիր caches, որպեսզի հիշի օգտատիրոջ ընտրությունը
      caches: ['localStorage', 'cookie']
    },
    interpolation: {
      escapeValue: false
    }
  });